/* =============================================================
   Bean Shipper — Theme JS
   Vanilla JS, no React. Loaded with `defer`. Runs on DOMContentLoaded.
============================================================= */
/* 13 Oct 2026: storefront cart calls carry the market root. Shopify.routes.root is "/" in
   Malaysia and "/en-sg/" in Singapore. A cart first created through the bare /cart/add.js was
   bound to Malaysia, so on /en-sg/ pages the drawer showed Malaysian shipping lines until the
   next page load. Every cart fetch in this file builds its path with bsUrl(). */
window.bsUrl = window.bsUrl || function (p) {
  return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + String(p).replace(/^\/+/, '');
};
(function () {
  'use strict';

  var BS = (window.BeanShipper = window.BeanShipper || {});
  BS.cart = null;

  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var on = function (el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts || false); };

  function rm(n) { return 'RM ' + Number(n).toFixed(0); }
  BS.rm = rm;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------------------------------------------------------
     1. REVEAL-ON-SCROLL — mirrors the React prototype's <Reveal>
  --------------------------------------------------------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseInt(e.target.getAttribute('data-reveal-delay') || 0, 10);
        setTimeout(function () { e.target.classList.add('is-in'); }, d);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    $$('.reveal, .split-line').forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     2. NAV — scroll state, mobile menu, cart toggle
  --------------------------------------------------------------- */
  function initNav() {
    var nav = $('.nav');
    if (!nav) return;
    var onScroll = function () {
      if (window.scrollY > 24) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    var burger = $('.nav__burger');
    var menu   = $('.mobile-menu');
    if (burger && menu) {
      on(burger, 'click', function () { menu.classList.add('is-open'); document.body.classList.add('no-scroll'); });
      on($('.mobile-menu__close', menu), 'click', function () { menu.classList.remove('is-open'); document.body.classList.remove('no-scroll'); });
      on(menu, 'click', function (e) { if (e.target === menu) { menu.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } });
    }

    $$('.nav__icon--cart, [data-cart-open]').forEach(function (btn) {
      on(btn, 'click', function (e) { e.preventDefault(); BS.cart && BS.cart.open(); });
    });
  }

  /* ---------------------------------------------------------------
     3. HERO PARALLAX — rotate the bean SVG on scroll
  --------------------------------------------------------------- */
  function initHeroParallax() {
    var bean = $('.hero__bean');
    if (!bean) return;
    var raf = null;
    function update() {
      var y = window.scrollY;
      bean.style.transform = 'translate(-50%,-50%) rotate(' + (y * 0.08).toFixed(2) + 'deg)';
      raf = null;
    }
    on(window, 'scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------
     4. CART — Shopify AJAX cart drawer
       Reads /cart.js, renders into [data-bs-cart-drawer]
       Watches add-to-cart forms with [data-bs-add]
  --------------------------------------------------------------- */
  function Cart() {
    var drawer  = $('[data-bs-cart-drawer]');
    var overlay = $('[data-bs-cart-overlay]');
    var body    = $('[data-bs-cart-body]');
    var foot    = $('[data-bs-cart-foot]');
    var count   = $('[data-bs-cart-count]');
    var badge   = $('[data-bs-cart-badge]');

    /* 11 Oct 2026: keep the sen. toFixed(0) showed RM33.15 as "RM 33" and RM79.55 as "RM 80",
       and paintShip() reads this subtotal text, so a RM79.55 cart was told it had unlocked free
       shipping while checkout still charged it. Whole amounts stay "RM 39"; thousands get a comma. */
    function fmt(cents) {
      cents = Math.round(Number(cents) || 0);
      var neg = cents < 0;
      if (neg) cents = -cents;
      var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var sen = cents % 100;
      return (neg ? '-' : '') + 'RM ' + whole + (sen ? '.' + (sen < 10 ? '0' : '') + sen : '');
    }

    var upsellCache = {};
    function upsellMoney(price) {
      if (price == null) return '';
      if (typeof price === 'string') { var f = parseFloat(price); return isNaN(f) ? '' : fmt(Math.round(f * 100)); }
      return fmt(price);
    }
    function paintUpsell(host, prods, inCart) {
      if (!host) return;
      var pick = [];
      for (var i = 0; i < prods.length && pick.length < 3; i++) {
        var p = prods[i];
        if (!p || inCart[p.id]) continue;
        var vs = p.variants || [];
        var v = null;
        for (var j = 0; j < vs.length; j++) { if (vs[j] && vs[j].available !== false) { v = vs[j]; break; } }
        if (!v && vs.length) v = vs[0];
        if (!v) continue;
        var im = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
        var ti = String(p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        pick.push({ id: v.id, img: im, title: ti, price: upsellMoney(v.price) });
      }
      if (!pick.length) { host.innerHTML = ''; return; }
      var heading = 'You might also like';
      host.innerHTML = '<div style="margin-top:18px;padding-top:16px;border-top:1px solid rgba(26,26,26,.1)">'
        + '<div style="font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#8c8c8c;font-weight:600;margin-bottom:12px">' + heading + '</div>'
        + pick.map(function (o) {
            return '<div style="display:flex;align-items:center;gap:12px;margin-bottom:12px">'
              + '<div style="width:48px;height:48px;flex:0 0 48px;border-radius:6px;background:#f3f0ea;background-image:url(' + o.img + ');background-size:cover;background-position:center"></div>'
              + '<div style="flex:1 1 auto;min-width:0"><div style="font-size:13px;font-weight:600;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + o.title + '</div>'
              + '<div style="font-size:12px;color:#6b6b6b">' + o.price + '</div></div>'
              + '<button type="button" data-bs-quick-add="' + o.id + '" style="flex:0 0 auto;border:1px solid var(--bs-red,#B61F2E);color:var(--bs-red,#B61F2E);background:#fff;font-size:12px;font-weight:600;padding:6px 12px;border-radius:99px;cursor:pointer">Add</button>'
              + '</div>';
          }).join('')
        + '</div>';
    }
    function renderUpsell(state) {
      var host = body && body.querySelector('[data-bs-cart-upsell]');
      if (!host) return;
      if (!state || !state.items || !state.items.length) { host.innerHTML = ''; return; }
      var inCart = {};
      state.items.forEach(function (it) { inCart[it.product_id] = true; });
      var key = 'c:bestseller';
      if (upsellCache[key]) { paintUpsell(host, upsellCache[key], inCart); return; }
      fetch(bsUrl('collections/bestseller/products.json?limit=16'), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data && data.products) || [];
          upsellCache[key] = prods;
          paintUpsell(host, prods, inCart);
        })
        .catch(function () { host.innerHTML = ''; });
    }
    function render(state) {
      if (!body) return;
      if (!state || !state.items || state.items.length === 0) {
        body.innerHTML = '<div class="cart__empty"><div class="cart__empty-mark">∅</div><p>Your bag is empty.</p><a href="' + bsUrl('collections/all-beans') + '" class="btn btn--primary">Browse beans</a></div>';
        if (foot) foot.style.display = 'none';
      } else {
        body.innerHTML = state.items.map(function (item) {
          var img = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
          var subTag = (item.selling_plan_allocation ? '<span class="cart-item__sub-tag">Subscription</span>' : '<span class="cart-item__onetime-tag">One-time</span>');
          var propsHtml = '';
          if (item.properties) {
            var propRows = '';
            Object.keys(item.properties).forEach(function (pk) {
              var pv = item.properties[pk];
              if (!pk || pk.charAt(0) === '_' || pv == null || pv === '') return;
              var ek = String(pk).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
              var ev = String(pv).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
              propRows += '<div style="margin-top:2px"><span style="font-weight:600">' + ek + ':</span> ' + ev + '</div>';
            });
            if (propRows) propsHtml = '<div class="cart-item__props" style="margin-top:5px;font-size:12px;line-height:1.45;color:#6b6b6b">' + propRows + '</div>';
          }
          return ''
            + '<div class="cart-item" data-key="' + item.key + '">'
            +   '<div class="cart-item__img" style="background-image:url(' + img + ')"></div>'
            +   '<div class="cart-item__body">'
            +     '<div class="cart-item__row">'
            +       '<div class="cart-item__name">' + item.product_title + '</div>'
            +       '<button class="cart-item__remove" data-bs-cart-remove>Remove</button>'
            +     '</div>'
            +     '<div class="cart-item__meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '&nbsp;') + ' ' + subTag + '</div>'
            +     propsHtml
            +     '<div class="cart-item__row">'
            +       '<div class="qty">'
            +         '<button data-bs-cart-qty="-1" aria-label="Decrease">−</button>'
            +         '<span>' + item.quantity + '</span>'
            +         '<button data-bs-cart-qty="1" aria-label="Increase">+</button>'
            +       '</div>'
            +       '<div class="cart-item__price">' + fmt(item.line_price) + '</div>'
            +     '</div>'
            +   '</div>'
            + '</div>';
        }).join('') + '<div data-bs-cart-upsell></div>';
        renderUpsell(state);
        if (foot) {
          foot.style.display = '';
          $('[data-bs-cart-subtotal]', foot).textContent = fmt(state.total_price);
          $('[data-bs-cart-checkout]', foot).textContent = 'Checkout · ' + fmt(state.total_price);
          /* 12 Aug CRO audit: repaint the free-shipping line on every foot patch —
             the MutationObserver in BS-CRO-MODULES dies once the ajax path swaps
             the foot node, leaving the bar stale after qty/remove changes. */
          if (window.__bsPaintShip) window.__bsPaintShip();
        }
      }
      if (count) count.textContent = state.item_count + ' item' + (state.item_count === 1 ? '' : 's');
      if (badge) {
        if (state.item_count > 0) {
          badge.textContent = state.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }
      BS.cart.state = state;
    }

    function fetchCart() {
      return fetch(bsUrl('cart.js'), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (state) { render(state); return state; });
    }

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      fetchCart();
    }
    function close() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    function add(form) {
      var fd = new FormData(form);
      return fetch(bsUrl('cart/add.js'), { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status && item.status >= 400) {
            BS.toast(item.description || 'Could not add to cart.', 'error');
            return null;
          }
          return fetchCart().then(function () { open(); BS.toast('Added to bag.'); return item; });
        })
        .catch(function () { BS.toast('Could not add to cart.', 'error'); });
    }

    function changeQty(key, delta) {
      var item = (BS.cart.state && BS.cart.state.items || []).filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var newQty = Math.max(0, item.quantity + delta);
      return fetch(bsUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: newQty }),
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(render);
    }

    function remove(key) {
      return fetch(bsUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 }),
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(render);
    }

    if (overlay) on(overlay, 'click', close);
    var closeBtn = $('[data-bs-cart-close]');
    if (closeBtn) on(closeBtn, 'click', close);

    if (drawer) {
      on(drawer, 'click', function (e) {
        var qb = e.target.closest('[data-bs-cart-qty]');
        var rm = e.target.closest('[data-bs-cart-remove]');
        if (qb) {
          var item = e.target.closest('.cart-item');
          if (item) changeQty(item.getAttribute('data-key'), parseInt(qb.getAttribute('data-bs-cart-qty'), 10));
        } else if (rm) {
          var item2 = e.target.closest('.cart-item');
          if (item2) remove(item2.getAttribute('data-key'));
        }
      });
    }

    on(document.body, 'submit', function (e) {
      var form = e.target.closest('form[data-bs-add]');
      if (!form) return;
      // The bean-shipper-ajax-cart snippet (rendered alongside the drawer)
      // also intercepts [data-bs-add] submits; when it is bound, defer to it
      // entirely or every add fires twice (double quantities in the cart).
      if (window.__bsAjaxCartBound) return;
      e.preventDefault();
      add(form);
    });

    on(document.body, 'click', function (e) {
      var qa = e.target.closest('[data-bs-quick-add]');
      if (!qa) return;
      e.preventDefault();
      var id = qa.getAttribute('data-bs-quick-add');
      if (!id) return;
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      fetch(bsUrl('cart/add.js'), { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status && item.status >= 400) { BS.toast(item.description || 'Could not add.', 'error'); return; }
          fetchCart(); open(); BS.toast('Added to bag.');
        });
    });

    return { open: open, close: close, refresh: fetchCart, add: add, state: null };
  }

  /* ---------------------------------------------------------------
     5. TOAST — small bottom-centre flash for cart success/errors
  --------------------------------------------------------------- */
  BS.toast = function (msg, type) {
    var t = document.createElement('div');
    t.className = 'bs-toast' + (type === 'error' ? ' is-error' : '');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { t.remove(); }, 350);
    }, 2400);
  };

  /* ---------------------------------------------------------------
     6. PDP — type/size/grind selectors, price recompute
       Works with [data-bs-pdp] container.
  --------------------------------------------------------------- */
  function initPDP() {
    var pdp = $('[data-bs-pdp]');
    if (!pdp) return;

    var variantData;
    try { variantData = JSON.parse(pdp.getAttribute('data-bs-variants') || '[]'); } catch (e) { variantData = []; }
    var defaultPrice = parseInt(pdp.getAttribute('data-bs-default-price') || 0, 10);
    var subDisc = parseFloat(pdp.getAttribute('data-bs-sub-discount') || '0.15');

    var state = { type: 'one-time', size: '300g', grind: 'Whole Bean' };
    var variantInput = $('[data-bs-variant-id]', pdp);
    var priceEl = $('[data-bs-pdp-price]', pdp);
    var subPriceEl = $('[data-bs-pdp-sub-price]', pdp);
    var oncePriceEl = $('[data-bs-pdp-once-price]', pdp);
    var sellingPlanInput = $('[data-bs-selling-plan]', pdp);
    var addBtn = $('[data-bs-pdp-add]', pdp);

    function findVariant() {
      // Try to match size + grind. If no exact, fall back to size, then default.
      var match = variantData.filter(function (v) {
        var t = (v.title || '').toLowerCase();
        return t.indexOf(state.size.toLowerCase()) >= 0 && t.indexOf(state.grind.toLowerCase()) >= 0;
      })[0];
      if (!match) match = variantData.filter(function (v) { return (v.title || '').toLowerCase().indexOf(state.size.toLowerCase()) >= 0; })[0];
      if (!match) match = variantData[0];
      return match;
    }

    function format(cents) { return 'RM ' + (cents / 100).toFixed(0); }

    function update() {
      var v = findVariant();
      if (!v) return;
      var basePrice = v.price; // cents
      var displayPrice = state.type === 'sub' ? Math.round(basePrice * (1 - subDisc)) : basePrice;
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = format(displayPrice);
      if (subPriceEl) subPriceEl.textContent = format(Math.round(basePrice * (1 - subDisc)));
      if (oncePriceEl) oncePriceEl.textContent = format(basePrice);
      if (addBtn) addBtn.textContent = 'Add to bag — ' + format(displayPrice);
      if (sellingPlanInput) {
        if (state.type === 'sub' && sellingPlanInput.getAttribute('data-bs-default-plan')) {
          sellingPlanInput.value = sellingPlanInput.getAttribute('data-bs-default-plan');
        } else {
          sellingPlanInput.value = '';
        }
      }
    }

    pdp.addEventListener('click', function (e) {
      var typeBtn = e.target.closest('[data-bs-pdp-type]');
      if (typeBtn) {
        state.type = typeBtn.getAttribute('data-bs-pdp-type');
        $$('[data-bs-pdp-type]', pdp).forEach(function (b) { b.classList.toggle('is-active', b === typeBtn); });
        update();
        return;
      }
      var sizeBtn = e.target.closest('[data-bs-pdp-size]');
      if (sizeBtn) {
        state.size = sizeBtn.getAttribute('data-bs-pdp-size');
        $$('[data-bs-pdp-size]', pdp).forEach(function (b) { b.classList.toggle('is-active', b === sizeBtn); });
        update();
        return;
      }
      var grindBtn = e.target.closest('[data-bs-pdp-grind]');
      if (grindBtn) {
        state.grind = grindBtn.getAttribute('data-bs-pdp-grind');
        $$('[data-bs-pdp-grind]', pdp).forEach(function (b) { b.classList.toggle('is-active', b === grindBtn); });
        update();
        return;
      }
    });

    update();
  }

  /* ---------------------------------------------------------------
     7. TASTING WHEEL — render a radar polygon from data attributes
       Container: [data-bs-wheel] with attrs:
         data-acidity="7" data-sweetness="8" data-body="7"
         data-bitterness="5" data-aroma="8" data-aftertaste="7"
  --------------------------------------------------------------- */
  function initTastingWheel() {
    $$('[data-bs-wheel]').forEach(function (host) {
      var labels = ['Acidity', 'Sweetness', 'Body', 'Bitterness', 'Aroma', 'Aftertaste'];
      var keys   = ['acidity','sweetness','body','bitterness','aroma','aftertaste'];
      var values = keys.map(function (k) { return parseFloat(host.getAttribute('data-' + k)) || 6; });
      var size = 320;
      var cx = 160, cy = 160;

      var rings = [3,5,7,9].map(function (r) {
        return '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r*14) + '" fill="none" stroke="var(--bs-rule)" stroke-width="0.5"/>';
      }).join('');

      var spokes = labels.map(function (label, i) {
        var ang = (i / labels.length) * Math.PI * 2 - Math.PI / 2;
        var lx = cx + Math.cos(ang) * 145;
        var ly = cy + Math.sin(ang) * 145;
        var dy = Math.sin(ang) > 0 ? 12 : -4;
        return '<line x1="'+cx+'" y1="'+cy+'" x2="'+lx+'" y2="'+ly+'" stroke="var(--bs-rule)" stroke-width="0.5"/>'
             + '<text x="'+lx+'" y="'+(ly+dy)+'" text-anchor="middle" font-size="9" fill="var(--bs-ink-3)" style="font-family:Gotham,sans-serif;letter-spacing:0.1em;text-transform:uppercase">'+label+'</text>';
      }).join('');

      var pts = values.map(function (v, i) {
        var ang = (i / values.length) * Math.PI * 2 - Math.PI / 2;
        var r = v * 14;
        return (cx + Math.cos(ang)*r) + ',' + (cy + Math.sin(ang)*r);
      }).join(' ');

      var dots = values.map(function (v, i) {
        var ang = (i / values.length) * Math.PI * 2 - Math.PI / 2;
        var r = v * 14;
        return '<circle cx="'+(cx + Math.cos(ang)*r)+'" cy="'+(cy + Math.sin(ang)*r)+'" r="3" fill="var(--bs-red)"/>';
      }).join('');

      host.innerHTML = '<svg viewBox="0 0 '+size+' '+size+'">'
        + rings + spokes
        + '<polygon points="'+pts+'" fill="var(--bs-red)" fill-opacity="0.18" stroke="var(--bs-red)" stroke-width="1.5"/>'
        + dots + '</svg>';
    });
  }

  /* ---------------------------------------------------------------
     8. SHOP PAGE — type & roast filters (client-side, on top of
       Shopify's collection product list)
  --------------------------------------------------------------- */
  function initShopFilters() {
    var grid = $('[data-bs-shop-grid]');
    if (!grid) return;
    var counter = $('[data-bs-shop-count]');
    var sortSelect = $('[data-bs-shop-sort]');

    var typeFilter = 'all';
    var roastFilter = 'all';

    function apply() {
      var cards = $$('.prod-card', grid);
      var visible = 0;
      cards.forEach(function (card) {
        var tags  = (card.getAttribute('data-tags') || '').toLowerCase();
        var roast = (card.getAttribute('data-roast') || '').toLowerCase();
        var typeOk = typeFilter === 'all'
          || (typeFilter === 'single' && tags.indexOf('single origin') >= 0)
          || (typeFilter === 'blend' && tags.indexOf('blend') >= 0)
          || (typeFilter === 'microlot' && tags.indexOf('microlot') >= 0)
          || (typeFilter === 'asia' && (tags.indexOf('asia') >= 0 || tags.indexOf('malaysia') >= 0))
          || (typeFilter === 'africa' && tags.indexOf('africa') >= 0)
          || (typeFilter === 'americas' && (tags.indexOf('central america') >= 0 || tags.indexOf('south america') >= 0));
        var roastOk = roastFilter === 'all' || roast.indexOf(roastFilter) >= 0;
        var show = typeOk && roastOk;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (counter) counter.textContent = visible + ' coffees';
    }

    function sort(key) {
      var cards = $$('.prod-card', grid);
      cards.sort(function (a, b) {
        if (key === 'price-low')  return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
        if (key === 'price-high') return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
        if (key === 'name')       return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
        return parseInt(a.getAttribute('data-pos') || 0, 10) - parseInt(b.getAttribute('data-pos') || 0, 10);
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    $$('[data-bs-shop-type]').forEach(function (btn) {
      on(btn, 'click', function () {
        typeFilter = btn.getAttribute('data-bs-shop-type');
        $$('[data-bs-shop-type]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        apply();
      });
    });
    $$('[data-bs-shop-roast]').forEach(function (btn) {
      on(btn, 'click', function () {
        roastFilter = btn.getAttribute('data-bs-shop-roast');
        $$('[data-bs-shop-roast]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        apply();
      });
    });
    if (sortSelect) on(sortSelect, 'change', function () { sort(sortSelect.value); });

    apply();
  }

  /* ---------------------------------------------------------------
     9. STORIES — category filter + active button
  --------------------------------------------------------------- */
  function initStoriesFilter() {
    var grid = $('[data-bs-stories-grid]');
    if (!grid) return;
    $$('[data-bs-story-cat]').forEach(function (btn) {
      on(btn, 'click', function () {
        var cat = btn.getAttribute('data-bs-story-cat');
        $$('[data-bs-story-cat]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        $$('.story-card', grid).forEach(function (card) {
          var c = (card.getAttribute('data-cat') || '').toLowerCase();
          card.style.display = (cat === 'all' || c === cat.toLowerCase()) ? '' : 'none';
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     10. SUBSCRIBE — tab switcher
  --------------------------------------------------------------- */
  function initSubscribeTabs() {
    var tabs = $$('[data-bs-sub-tab]');
    if (!tabs.length) return;

    function showTab(id) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-bs-sub-tab') === id); });
      $$('[data-bs-sub-panel]').forEach(function (panel) {
        panel.style.display = panel.getAttribute('data-bs-sub-panel') === id ? '' : 'none';
      });
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('tab', id);
        history.replaceState(null, '', url);
      }
    }

    tabs.forEach(function (t) {
      on(t, 'click', function () { showTab(t.getAttribute('data-bs-sub-tab')); });
    });

    var qs = new URLSearchParams(window.location.search);
    var initial = qs.get('tab') || (tabs[0] && tabs[0].getAttribute('data-bs-sub-tab'));
    if (initial) showTab(initial);
  }

  /* ---------------------------------------------------------------
     11. SUBSCRIBE BUILDER — bag selector with discount tier
       Wrapper: [data-bs-builder]
       Each product card: [data-bs-builder-card][data-id][data-price][data-variant]
  --------------------------------------------------------------- */
  function initBuilder() {
    var root = $('[data-bs-builder]');
    if (!root) return;
    var sizeMultMap = { '300g': 1, '600g': 1.85, '1kg': 3 };
    var state = { selected: {}, size: '300g', grind: 'Whole Bean', cadence: '2w' };

    function priceOf(card) {
      return parseFloat(card.getAttribute('data-price')) * (sizeMultMap[state.size] || 1);
    }

    function totals() {
      var bags = 0, subtotal = 0;
      Object.keys(state.selected).forEach(function (id) {
        var qty = state.selected[id];
        var card = root.querySelector('[data-bs-builder-card][data-id="' + id + '"]');
        if (!card) return;
        bags += qty;
        subtotal += priceOf(card) * qty;
      });
      return { bags: bags, subtotal: subtotal };
    }

    function discountFor(bags) {
      if (bags >= 4) return 0.15;
      if (bags >= 3) return 0.10;
      if (bags >= 2) return 0.05;
      return 0;
    }

    function render() {
      $$('[data-bs-builder-card]', root).forEach(function (card) {
        var id = card.getAttribute('data-id');
        var qty = state.selected[id] || 0;
        card.classList.toggle('is-selected', qty > 0);
        var plus  = $('[data-bs-builder-add]', card);
        var qtyEl = $('[data-bs-builder-qty]', card);
        var price = $('[data-bs-builder-price]', card);
        if (price) price.textContent = rm(priceOf(card));
        if (qty === 0) {
          if (plus) plus.style.display = '';
          if (qtyEl) qtyEl.style.display = 'none';
        } else {
          if (plus) plus.style.display = 'none';
          if (qtyEl) {
            qtyEl.style.display = '';
            $('[data-bs-builder-num]', qtyEl).textContent = qty;
          }
        }
      });

      var t = totals();
      var disc = discountFor(t.bags);
      var grand = t.subtotal * (1 - disc);

      $$('[data-bs-builder-tier]', root).forEach(function (tier) {
        var lvl = parseInt(tier.getAttribute('data-bs-builder-tier'), 10);
        tier.classList.toggle('is-on',
          (lvl === 1 && t.bags >= 1) ||
          (lvl === 2 && t.bags >= 2) ||
          (lvl === 3 && t.bags >= 4)
        );
      });

      var bagCount = $('[data-bs-builder-bagcount]', root);
      if (bagCount) bagCount.textContent = t.bags + ' bag' + (t.bags === 1 ? '' : 's') + ' · ' + state.size;

      var list = $('[data-bs-builder-list]', root);
      if (list) {
        if (t.bags === 0) {
          list.innerHTML = '<div class="builder__cart-empty">Pick a bean to start.</div>';
        } else {
          list.innerHTML = Object.keys(state.selected).map(function (id) {
            var qty = state.selected[id];
            var card = root.querySelector('[data-bs-builder-card][data-id="' + id + '"]');
            if (!card) return '';
            var name = card.getAttribute('data-name') || '';
            var img  = card.getAttribute('data-img') || '';
            return '<div class="builder__cart-row">'
              + '<span class="builder__cart-img" style="background-image:url(' + img + ')"></span>'
              + '<span class="builder__cart-name">' + qty + '× ' + name + '</span>'
              + '<span class="builder__cart-price">' + rm(priceOf(card) * qty) + '</span>'
              + '</div>';
          }).join('');
        }
      }

      var sub = $('[data-bs-builder-subtotal]', root); if (sub) sub.textContent = rm(t.subtotal);
      var dl  = $('[data-bs-builder-discount-line]', root);
      var dpct = $('[data-bs-builder-discount-pct]', root);
      var damt = $('[data-bs-builder-discount-amt]', root);
      if (dl) dl.style.display = disc > 0 ? '' : 'none';
      if (dpct) dpct.textContent = Math.round(disc * 100) + '%';
      if (damt) damt.textContent = rm(t.subtotal * disc);
      var grandEl = $('[data-bs-builder-grand]', root); if (grandEl) grandEl.textContent = rm(grand);

      var btn = $('[data-bs-builder-submit]', root);
      if (btn) {
        btn.disabled = t.bags === 0;
        btn.textContent = t.bags === 0 ? 'Pick at least one bean' : ('Start subscription · ' + rm(grand));
      }
    }

    on(root, 'click', function (e) {
      var addBtn = e.target.closest('[data-bs-builder-add]');
      var inc    = e.target.closest('[data-bs-builder-inc]');
      var dec    = e.target.closest('[data-bs-builder-dec]');
      if (addBtn) {
        var card = addBtn.closest('[data-bs-builder-card]');
        var id = card && card.getAttribute('data-id');
        if (id) { state.selected[id] = (state.selected[id] || 0) + 1; render(); }
      } else if (inc) {
        var card2 = inc.closest('[data-bs-builder-card]');
        var id2 = card2 && card2.getAttribute('data-id');
        if (id2) { state.selected[id2] = (state.selected[id2] || 0) + 1; render(); }
      } else if (dec) {
        var card3 = dec.closest('[data-bs-builder-card]');
        var id3 = card3 && card3.getAttribute('data-id');
        if (id3) {
          state.selected[id3] = Math.max(0, (state.selected[id3] || 0) - 1);
          if (state.selected[id3] === 0) delete state.selected[id3];
          render();
        }
      }

      var sizeBtn = e.target.closest('[data-bs-builder-size]');
      if (sizeBtn) {
        state.size = sizeBtn.getAttribute('data-bs-builder-size');
        $$('[data-bs-builder-size]', root).forEach(function (b) { b.classList.toggle('is-active', b === sizeBtn); });
        render();
      }
      var cadBtn = e.target.closest('[data-bs-builder-cadence]');
      if (cadBtn) {
        state.cadence = cadBtn.getAttribute('data-bs-builder-cadence');
        $$('[data-bs-builder-cadence]', root).forEach(function (b) { b.classList.toggle('is-active', b === cadBtn); });
      }
    });

    on(root, 'change', function (e) {
      if (e.target.matches('[data-bs-builder-grind]')) state.grind = e.target.value;
    });

    var submit = $('[data-bs-builder-submit]', root);
    if (submit) {
      on(submit, 'click', function () {
        var ids = Object.keys(state.selected);
        if (ids.length === 0) return;
        // Sequentially add each selected variant to the cart with sub selling plan
        var plan = root.getAttribute('data-bs-builder-plan') || '';
        var queue = [];
        ids.forEach(function (id) {
          var qty = state.selected[id];
          var card = root.querySelector('[data-bs-builder-card][data-id="' + id + '"]');
          if (!card) return;
          var variant = card.getAttribute('data-variant');
          if (!variant) return;
          queue.push({ id: variant, quantity: qty });
        });
        var fd = { items: queue };
        if (plan) fd.items.forEach(function (i) { i.selling_plan = plan; });
        fetch(bsUrl('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: JSON.stringify(fd)
        }).then(function (r) {
          if (!r.ok) throw new Error('subscription bundle add failed');
          return r.json();
        }).then(function () {
          BS.cart && BS.cart.refresh();
          BS.cart && BS.cart.open();
          BS.toast('Subscription bundle added.');
        }).catch(function () {
          BS.toast('Could not add to cart.', 'error');
        });
      });
    }

    render();
  }

  /* ---------------------------------------------------------------
     12. QUIZ — 4 questions → recommendation
       Container [data-bs-quiz] with [data-bs-products] = JSON array of products
       (id, handle, url, image, name, roast, origin, tags[], notes[], blurb, price)
  --------------------------------------------------------------- */

  /* ---------------------------------------------------------------
     BUNDLE BUILDER (one-time, /pages/bundle)
     Pick any combination of products. Tier discounts apply:
       2 items = 5% off, 3 items = 10% off, 4+ items = 15% off
     Single "Add to bag" call posts every selected variant to /cart/add.js.
  --------------------------------------------------------------- */
  function initBundleBuilder() {
    var root = $('[data-bs-bundle]');
    if (!root) return;

    var state = {}; // variant_id -> { qty, name, price, image, card }
    var TIERS = [
      { min: 4, pct: 15 },
      { min: 3, pct: 10 },
      { min: 2, pct: 5  },
      { min: 0, pct: 0  }
    ];

    var filterTabs = $$('[data-bs-bundle-filter]', root);
    var cards      = $$('[data-bs-bundle-card]', root);
    var tierEls    = $$('[data-bs-bundle-tier]', root);
    var summaryItems = $('[data-bs-bundle-items]', root);
    var subtotalEl   = $('[data-bs-bundle-subtotal]', root);
    var discountPctEl = $('[data-bs-bundle-discount-pct]', root);
    var savingsRow   = $('[data-bs-bundle-savings-row]', root);
    var savingsEl    = $('[data-bs-bundle-savings]', root);
    var totalEl      = $('[data-bs-bundle-total]', root);
    var countEl      = $('[data-bs-bundle-count]', root);
    var addCta       = $('[data-bs-bundle-add]', root);

    function currentTier(itemCount) {
      for (var i = 0; i < TIERS.length; i++) {
        if (itemCount >= TIERS[i].min) return TIERS[i];
      }
      return TIERS[TIERS.length - 1];
    }

    function totals() {
      var count = 0, subtotal = 0;
      Object.keys(state).forEach(function (vid) {
        var line = state[vid];
        count += line.qty;
        subtotal += line.qty * line.price;
      });
      var tier = currentTier(count);
      var savings = subtotal * (tier.pct / 100);
      return { count: count, subtotal: subtotal, savings: savings, total: subtotal - savings, pct: tier.pct };
    }

    function rm(amount) {
      return 'RM ' + (amount || 0).toFixed(2);
    }

    function render() {
      var t = totals();

      // Count + tier highlight
      if (countEl) countEl.textContent = t.count;
      tierEls.forEach(function (el) {
        var min = parseInt(el.getAttribute('data-bs-bundle-tier'), 10);
        var active = (t.count >= min) && (t.count < (TIERS.find(function (x) { return x.min > min; }) || { min: Infinity }).min);
        // Simpler: highlight the highest tier the user qualifies for
        el.classList.toggle('is-active', false);
      });
      // Highlight the active tier
      var tier = currentTier(t.count);
      tierEls.forEach(function (el) {
        var min = parseInt(el.getAttribute('data-bs-bundle-tier'), 10);
        el.classList.toggle('is-active', min === tier.min && tier.pct > 0);
      });

      // Summary items list
      if (summaryItems) {
        if (t.count === 0) {
          summaryItems.innerHTML = '<p class="bundle-summary__empty">Pick a bag to start. Tier discounts apply automatically as you add.</p>';
        } else {
          var html = '';
          Object.keys(state).forEach(function (vid) {
            var line = state[vid];
            if (!line.qty) return;
            html += '<div class="bundle-summary__item">'
              + (line.image ? '<div class="bundle-summary__item-img" style="background-image:url(' + line.image + ')"></div>' : '<div class="bundle-summary__item-img"></div>')
              + '<div class="bundle-summary__item-body">'
              +   '<div class="bundle-summary__item-name">' + line.name + '</div>'
              +   '<div class="bundle-summary__item-meta">' + line.qty + ' × ' + rm(line.price) + '</div>'
              + '</div>'
              + '<button type="button" class="bundle-summary__item-remove" data-bs-bundle-remove="' + vid + '" aria-label="Remove">×</button>'
              + '</div>';
          });
          summaryItems.innerHTML = html;
        }
      }

      // Totals
      if (subtotalEl) subtotalEl.textContent = rm(t.subtotal);
      if (totalEl)    totalEl.textContent = rm(t.total);
      if (savingsRow) savingsRow.style.display = t.pct > 0 ? '' : 'none';
      if (discountPctEl) discountPctEl.textContent = t.pct + '%';
      if (savingsEl) savingsEl.textContent = rm(t.savings);

      // CTA
      if (addCta) {
        if (t.count === 0) {
          addCta.disabled = true;
          addCta.textContent = 'Pick at least one item';
        } else {
          addCta.disabled = false;
          var label = t.pct > 0
            ? 'Add ' + t.count + ' to bag · ' + rm(t.total) + ' (save ' + t.pct + '%)'
            : 'Add ' + t.count + ' to bag · ' + rm(t.total);
          addCta.textContent = label;
        }
      }
    }

    function adjust(card, delta) {
      var vid   = card.getAttribute('data-bs-bundle-variant-id');
      var name  = card.getAttribute('data-bs-bundle-name');
      var price = parseFloat(card.getAttribute('data-bs-bundle-price') || '0');
      var image = card.getAttribute('data-bs-bundle-image') || '';
      if (!state[vid]) state[vid] = { qty: 0, name: name, price: price, image: image, card: card };
      state[vid].qty = Math.max(0, state[vid].qty + delta);

      // Sync card UI
      var qtyEl = card.querySelector('[data-bs-bundle-qty]');
      if (qtyEl) qtyEl.textContent = state[vid].qty;
      card.classList.toggle('is-selected', state[vid].qty > 0);

      render();
    }

    // Filter tabs
    filterTabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterTabs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var f = btn.getAttribute('data-bs-bundle-filter');
        cards.forEach(function (c) {
          var t = c.getAttribute('data-bs-bundle-filter-type');
          c.style.display = (f === 'all' || t === f) ? '' : 'none';
        });
      });
    });

    // +/-/Add to bundle buttons on cards
    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bs-bundle-card]');
      if (card) {
        if (e.target.closest('[data-bs-bundle-increment]'))    { adjust(card, 1);  return; }
        if (e.target.closest('[data-bs-bundle-decrement]'))    { adjust(card, -1); return; }
        if (e.target.closest('[data-bs-bundle-add-one]'))      { adjust(card, 1);  return; }
      }
      var removeBtn = e.target.closest('[data-bs-bundle-remove]');
      if (removeBtn) {
        var vid = removeBtn.getAttribute('data-bs-bundle-remove');
        if (state[vid]) {
          state[vid].qty = 0;
          var qtyEl = state[vid].card && state[vid].card.querySelector('[data-bs-bundle-qty]');
          if (qtyEl) qtyEl.textContent = '0';
          state[vid].card && state[vid].card.classList.remove('is-selected');
          render();
        }
        return;
      }
    });

    // Add-to-bag → POST every selected variant to /cart/add.js
    if (addCta) {
      addCta.addEventListener('click', function () {
        var t = totals();
        if (t.count === 0) return;
        var items = [];
        var bundleTag = 'bundle-' + t.pct + 'off';
        Object.keys(state).forEach(function (vid) {
          var line = state[vid];
          if (line.qty > 0) items.push({ id: vid, quantity: line.qty, properties: { '_bundle_tag': bundleTag, '_bundle_savings_pct': String(t.pct) } });
        });
        addCta.disabled = true;
        addCta.textContent = 'Adding…';
        fetch(bsUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw new Error('bundle add failed'); return r.json(); }).then(function () {
          BS.cart && BS.cart.refresh && BS.cart.refresh();
          if (typeof BS.openCart === 'function') BS.openCart();
          else {
            var cartBtn = document.querySelector('[data-bs-cart-open], .nav__icon--cart');
            cartBtn && cartBtn.click();
          }
          // Reset state
          state = {};
          cards.forEach(function (c) {
            c.classList.remove('is-selected');
            var q = c.querySelector('[data-bs-bundle-qty]'); if (q) q.textContent = '0';
          });
          render();
        }).catch(function (err) {
          console.error('[BS bundle] add to cart failed:', err);
          addCta.disabled = false;
          addCta.textContent = 'Add failed — retry';
        });
      });
    }

    render();
  }

  /* ---------------------------------------------------------------
     FIND MY BEANS QUIZ (redesigned May 2026)
     4 questions: brew → roast → flavor → origin.
     Scoring: origin +4, roast +3, flavor +3, brew +2.5.
     Result: 1 hero + 2 alternates.
  --------------------------------------------------------------- */
  function initQuiz() {
    var root = $('[data-bs-quiz]');
    if (!root) return;

    var products = [];
    var jsonNode = $('[data-bs-quiz-products]', root);
    if (jsonNode) {
      try { products = JSON.parse(jsonNode.textContent.trim() || '[]'); }
      catch (e) { console.warn('[BS] quiz products JSON parse failed:', e); products = []; }
    }
    if (!products.length) {
      console.warn('[BS] quiz: no products in pool. Check the quiz_collection setting.');
    }

    var Q_ORDER = ['brew', 'roast', 'flavor', 'origin'];
    var Q_LABELS = { brew: 'Brew', roast: 'Roast', flavor: 'Flavor', origin: 'Origin' };
    var OPTION_LABELS = {
      espresso: 'Espresso', drip: 'Pour-over', aeropress: 'AeroPress', 'french-press': 'French Press', 'moka-pot': 'Moka Pot',
      'light-roast': 'Light', 'medium-roast': 'Medium', 'dark-roast': 'Dark',
      chocolate: 'Chocolate', fruity: 'Fruity', floral: 'Floral', nutty: 'Nutty', caramel: 'Caramel',
      africa: 'Africa', americas: 'Americas', 'asia-pacific': 'Asia-Pacific'
    };

    var view = { intro: $('[data-bs-quiz-view="intro"]', root), questions: $('[data-bs-quiz-view="questions"]', root), result: $('[data-bs-quiz-view="result"]', root) };
    var qPanels = $$('[data-bs-quiz-q]', root);
    var stepEls = $$('[data-bs-quiz-step]', root);
    var stepNumEl = $('[data-bs-quiz-step-num]', root);
    var answeredEl1 = $('[data-bs-quiz-answered]', root);
    var answeredEl2 = $('[data-bs-quiz-answered-2]', root);
    var backBtn = $('[data-bs-quiz-back]', root);
    var nextBtn = $('[data-bs-quiz-next]', root);
    var resultGrid = $('[data-bs-quiz-result-grid]', root);
    var summaryEl = $('[data-bs-quiz-summary]', root);

    var step = 0;
    var answers = {};

    function showView(name) {
      Object.keys(view).forEach(function (k) {
        if (view[k]) view[k].style.display = (k === name) ? '' : 'none';
      });
    }

    function showQuestion(idx) {
      step = Math.max(0, Math.min(Q_ORDER.length - 1, idx));
      var qid = Q_ORDER[step];
      qPanels.forEach(function (p) {
        p.style.display = (p.getAttribute('data-bs-quiz-q') === qid) ? '' : 'none';
      });
      stepEls.forEach(function (s, i) {
        s.classList.toggle('is-active', i === step);
        s.classList.toggle('is-done', !!answers[Q_ORDER[i]]);
        s.disabled = !(answers[Q_ORDER[i]] || i <= step);
      });
      if (stepNumEl) stepNumEl.textContent = step + 1;
      if (backBtn) backBtn.disabled = step === 0;
      if (nextBtn) {
        var has = !!answers[qid];
        nextBtn.disabled = !has;
        nextBtn.textContent = step === Q_ORDER.length - 1 ? 'See my beans →' : 'Continue →';
      }
      var answeredCount = Object.keys(answers).length;
      if (answeredEl1) answeredEl1.textContent = answeredCount;
      if (answeredEl2) answeredEl2.textContent = answeredCount;
    }

    function scoreProduct(p) {
      var s = 0;
      if (p.match_origin === answers.origin) s += 4;
      if (p.match_roast === answers.roast) s += 3;
      if ((p.match_brew || []).indexOf(answers.brew) !== -1) s += 2.5;
      if ((p.match_flavor || []).indexOf(answers.flavor) !== -1) s += 3;
      s += Math.random() * 0.1; // tie-breaker
      return s;
    }

    function rankProducts() {
      return products.slice()
        .map(function (p) { return { p: p, s: scoreProduct(p) }; })
        .sort(function (a, b) { return b.s - a.s; })
        .map(function (x) { return x.p; });
    }

    function renderSummary() {
      if (!summaryEl) return;
      summaryEl.innerHTML = Q_ORDER.map(function (qid) {
        var label = OPTION_LABELS[answers[qid]] || '';
        return '<span>' + Q_LABELS[qid] + ' · <strong>' + label + '</strong></span>';
      }).join('');
    }

    function renderResult() {
      if (!resultGrid) return;
      if (!products.length) {
        resultGrid.innerHTML = '<p style="grid-column:1/-1;text-align:center;padding:40px;color:var(--bs-ink-3)">No products in the matching pool. Set a collection in section settings.</p>';
        return;
      }
      var ranked = rankProducts();
      var top = ranked[0];
      var alts = ranked.slice(1, 3);

      var heroHtml = '<article class="result-product is-feature">'
        + (top.image ? '<div class="result-product__img" style="background-image:url(' + top.image + ')"></div>' : '')
        + '<div class="result-product__rank">01</div>'
        + '<div class="result-product__eyebrow">' + (top.origin_label || '') + '</div>'
        + '<h3 class="result-product__name">' + top.name + '</h3>'
        + '<p class="result-product__notes">' + (top.body || '') + '</p>'
        + '<div class="result-product__tags">' + (top.tags || []).slice(0, 4).map(function (t) { return '<span class="result-product__tag">' + t + '</span>'; }).join('') + '</div>'
        + (top.notes ? '<div style="font-size:13px;color:rgba(255,255,255,.78);margin-bottom:16px"><em style="font-family:var(--font-display);font-size:16px">Tasting notes — </em>' + top.notes + '</div>' : '')
        + '<div class="result-product__foot">'
        +   '<span class="result-product__price">' + (top.price_formatted || '') + '</span>'
        +   '<button class="btn" style="background:white;color:var(--bs-red);border-color:white" data-bs-quick-add="' + top.variant_id + '">Add to bag →</button>'
        + '</div>'
        + '</article>';

      var altsHtml = alts.map(function (p, i) {
        return '<article class="result-product">'
          + (p.image ? '<div class="result-product__img" style="background-image:url(' + p.image + ')"></div>' : '')
          + '<div class="result-product__rank">0' + (i + 2) + '</div>'
          + '<div class="result-product__eyebrow">' + (p.origin_label || '') + '</div>'
          + '<h3 class="result-product__name">' + p.name + '</h3>'
          + (p.notes ? '<div style="font-size:13px;color:var(--bs-ink-2);margin-bottom:16px;font-family:var(--font-display);font-style:italic">' + p.notes + '</div>' : '')
          + '<p class="result-product__notes">' + (p.body || '') + '</p>'
          + '<div class="result-product__tags">' + (p.tags || []).slice(0, 3).map(function (t) { return '<span class="result-product__tag">' + t + '</span>'; }).join('') + '</div>'
          + '<div class="result-product__foot">'
          +   '<span class="result-product__price">' + (p.price_formatted || '') + '</span>'
          +   '<a class="btn btn--secondary btn--sm" href="' + p.url + '">View →</a>'
          + '</div>'
          + '</article>';
      }).join('');

      resultGrid.innerHTML = heroHtml + altsHtml;
      renderSummary();
    }

    function selectOption(qid, optId, btn) {
      answers[qid] = optId;
      // Toggle active state on this question's options
      $$('[data-bs-quiz-option][data-bs-quiz-q-id="' + qid + '"]', root).forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      // Step answer label
      var stepAnswer = $('[data-bs-quiz-step-answer="' + qid + '"]', root);
      if (stepAnswer) stepAnswer.textContent = OPTION_LABELS[optId] || optId;
      // Re-render step state + advance after a tick
      var qi = Q_ORDER.indexOf(qid);
      if (qi === step) {
        showQuestion(step);
        setTimeout(function () {
          if (step < Q_ORDER.length - 1) showQuestion(step + 1);
        }, 350);
      } else {
        // re-selecting an earlier answer — stay on current step
        showQuestion(step);
      }
    }

    // Wire up: start button (intro → questions)
    var startBtn = $('[data-bs-quiz-start]', root);
    if (startBtn) startBtn.addEventListener('click', function () { showView('questions'); showQuestion(0); });

    // Wire up: step jumps
    stepEls.forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        showQuestion(i);
      });
    });

    // Wire up: option clicks (delegated)
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-bs-quiz-option]');
      if (opt) {
        selectOption(opt.getAttribute('data-bs-quiz-q-id'), opt.getAttribute('data-bs-quiz-option-id'), opt);
        return;
      }
      var retake = e.target.closest('[data-bs-quiz-retake]');
      if (retake) {
        answers = {};
        $$('[data-bs-quiz-option].is-selected', root).forEach(function (b) { b.classList.remove('is-selected'); });
        $$('[data-bs-quiz-step-answer]', root).forEach(function (s) { s.textContent = ''; });
        showView('intro');
        showQuestion(0);
        return;
      }
    });

    // Back + Next
    if (backBtn) backBtn.addEventListener('click', function () { if (step > 0) showQuestion(step - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var qid = Q_ORDER[step];
      if (!answers[qid]) return;
      if (step < Q_ORDER.length - 1) {
        showQuestion(step + 1);
      } else {
        showView('result');
        renderResult();
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      }
    });

    // Initial state — intro view
    showView('intro');
    showQuestion(0);
  }

  /* ---------------------------------------------------------------
     13. NEWSLETTER — submit to Shopify customer endpoint
  --------------------------------------------------------------- */
  function initNewsletter() {
    $$('[data-bs-newsletter]').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var input = $('input[type="email"]', form);
        if (!input || !input.value.match(/@/)) return;
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[tags]', 'newsletter');
        fd.append('contact[email]', input.value);
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('newsletter subscribe failed');
            var sent = form.parentNode && form.parentNode.querySelector('[data-bs-newsletter-sent]');
            if (sent) {
              var em = sent.querySelector('em');
              if (em) em.textContent = input.value;
              form.style.display = 'none';
              sent.style.display = '';
            } else {
              BS.toast("On its way to your inbox.");
              form.reset();
            }
          })
          .catch(function () {
            BS.toast('Sorry, that did not go through. Please try again.', 'error');
          });
      });
    });
  }

  /* ---------------------------------------------------------------
     14. NAV — link active state from current path
  --------------------------------------------------------------- */
  function initNavActive() {
    var path = window.location.pathname;
    $$('.nav__link').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href && href !== '/' && path.indexOf(href) === 0) a.classList.add('is-active');
      else if (href === '/' && path === '/') a.classList.add('is-active');
    });
  }

  /* ---------------------------------------------------------------
     BOOT
  --------------------------------------------------------------- */
  ready(function () {
    BS.cart = Cart();
    initReveal();
    initNav();
    initNavActive();
    initHeroParallax();
    initPDP();
    initTastingWheel();
    initShopFilters();
    initStoriesFilter();
    initSubscribeTabs();
    initBuilder();
    initBundleBuilder();
    initQuiz();
    initNewsletter();
    BS.cart.refresh();
  });

})();


/* ============================================================
   Bean Shipper - Prepaid Subscription buy box (global)
   Runs from bean-shipper.js (layout-level, executes reliably).
   The section's inline <script> does not run inside the theme's
   dynamic-section container, so the Coffee/Bags selector, price,
   selling_plan and cart variant were stuck on the default.
   Document-level event delegation -> survives section injection
   and app re-render. Pure ASCII only.
   ============================================================ */
(function(){
  if (window.__bsqBuybox) return; window.__bsqBuybox = true;
  var MID = "·", MUL = "×";
  function root(){ return document.querySelector('.bsq[data-bsq-root]'); }
  function vars(r){ try { return JSON.parse(r.getAttribute('data-bsq-variants') || '[]'); } catch(e){ return []; } }
  function months(r){ return parseInt(r.getAttribute('data-bsq-months'), 10) || 3; }
  function fbPlan(r){ return r.getAttribute('data-bsq-fallback-plan') || ''; }
  function rm(c){ return 'RM' + Math.round(c/100); }
  var state = { coffee:null, bags:null };
  function seed(r){
    if (state.coffee == null){ var c = r.querySelector('[data-bsq-coffee].sel') || r.querySelector('[data-bsq-coffee]'); state.coffee = c ? c.getAttribute('data-bsq-coffee') : null; }
    if (state.bags == null){ var b = r.querySelector('[data-bsq-bags].sel') || r.querySelector('[data-bsq-bags]'); state.bags = b ? b.getAttribute('data-bsq-bags') : null; }
  }
  function find(vs){ return vs.filter(function(v){ return (state.coffee==null||v.o1===state.coffee) && (state.bags==null||v.o2===state.bags); })[0] || vs[0]; }
  function render(){
    var r = root(); if (!r) return; seed(r);
    var vs = vars(r); if (!vs.length) return;
    var m = months(r), fb = fbPlan(r), v = find(vs); if (!v) return;
    var idI = r.querySelector('[data-bsq-id]'); if (idI) idI.value = v.id;
    var plI = r.querySelector('[data-bsq-plan]'); if (plI) plI.value = (v.plan != null ? v.plan : fb) || '';
    var i, els;
    els = r.querySelectorAll('[data-bsq-coffee]'); for (i=0;i<els.length;i++) els[i].classList.toggle('sel', els[i].getAttribute('data-bsq-coffee')===state.coffee);
    els = r.querySelectorAll('[data-bsq-bags]'); for (i=0;i<els.length;i++) els[i].classList.toggle('sel', els[i].getAttribute('data-bsq-bags')===state.bags);
    var pc = r.querySelector('[data-bsq-pick-coffee]'); if (pc && state.coffee) pc.textContent = state.coffee;
    var pb = r.querySelector('[data-bsq-pick-bags]'); if (pb && state.bags) pb.textContent = state.bags;
    var perMo = v.price, total = v.price * m;
    var a = r.querySelector('[data-bsq-permo]'); if (a) a.textContent = rm(perMo);
    var t = r.querySelector('[data-bsq-total]'); if (t) t.textContent = rm(total);
    var s = r.querySelector('[data-bsq-summary]'); if (s) s.innerHTML = (state.coffee||'') + ' ' + MID + ' ' + (state.bags||'') + '/mo ' + MUL + ' ' + m + ' shipments ' + MID + ' <b>free shipping</b>';
    var sa = r.querySelector('[data-bsq-sticky-amt]'); if (sa) sa.textContent = rm(perMo);
    var ss = r.querySelector('[data-bsq-sticky-sub]'); if (ss) ss.textContent = (state.coffee||'') + ' ' + MID + ' ' + (state.bags||'') + '/mo ' + MID + ' ' + m + '-month prepaid';
    els = r.querySelectorAll('[data-bsq-bagprice]');
    for (i=0;i<els.length;i++){ var bv = els[i].getAttribute('data-bsq-bagprice'); var vv = vs.filter(function(x){ return (state.coffee==null||x.o1===state.coffee) && x.o2===bv; })[0]; els[i].textContent = vv ? rm(vv.price) + '/mo' : ''; }
  }
  document.addEventListener('click', function(e){
    var r = root(); if (!r || !e.target.closest) return; var el;
    if ((el = e.target.closest('[data-bsq-coffee]')) && r.contains(el)){ state.coffee = el.getAttribute('data-bsq-coffee'); render(); return; }
    if ((el = e.target.closest('[data-bsq-bags]')) && r.contains(el)){ state.bags = el.getAttribute('data-bsq-bags'); render(); return; }
    if ((el = e.target.closest('[data-bsq-jump]')) && r.contains(el)){ window.scrollTo({ top:0, behavior:'smooth' }); return; }
    if ((el = e.target.closest('.bsq-faqq')) && r.contains(el)){ var it = el.closest('.bsq-faqitem'); if (it){ var ans = it.querySelector('.bsq-faqa'); var op = it.classList.toggle('open'); if (ans) ans.style.maxHeight = op ? ans.scrollHeight + 'px' : '0px'; } return; }
  }, false);
  function countUp(el){
    var raw = el.getAttribute('data-count') || '0', target = parseFloat(raw) || 0;
    var dec = raw.indexOf('.') > -1 ? 1 : 0, suf = el.getAttribute('data-suffix') || '', dur = 1300, t0 = null;
    function tick(now){ if (t0==null) t0 = now; var p = Math.min(1, (now - t0)/dur), e = 1 - Math.pow(1-p, 3); el.textContent = (target*e).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(tick); else el.textContent = target.toLocaleString('en-US') + suf; }
    requestAnimationFrame(tick);
  }
  var io = null;
  function arm(){
    var r = root(); if (!r) return; r.classList.add('bsq--anim');
    if (!('IntersectionObserver' in window)){ var all = r.querySelectorAll('[data-reveal],[data-count]'); for (var k=0;k<all.length;k++){ all[k].classList.add('in'); if (all[k].hasAttribute('data-count')) countUp(all[k]); } return; }
    if (!io){ io = new IntersectionObserver(function(ents){ ents.forEach(function(en){ if (!en.isIntersecting) return; en.target.classList.add('in'); if (en.target.hasAttribute('data-count')) countUp(en.target); io.unobserve(en.target); }); }, { threshold:0, rootMargin:'0px 0px -8% 0px' }); }
    var els = r.querySelectorAll('[data-reveal]:not(.in),[data-count]:not(.in)'); for (var j=0;j<els.length;j++) io.observe(els[j]);
  }
  function beans(){
    var r = root(); if (!r) return; var cs = r.querySelectorAll('[data-bsq-beans]');
    for (var c=0;c<cs.length;c++){ var box = cs[c]; if (box.getAttribute('data-bsq-beans-done')) continue; box.setAttribute('data-bsq-beans-done','1');
      for (var i=0;i<14;i++){ var b = document.createElement('span'); b.className = 'bsq-bean-p'; var sz = 6 + (i*1.3 % 16); b.style.width = sz + 'px'; b.style.height = (sz*1.35) + 'px'; b.style.left = ((i*37)%100) + '%'; b.style.top = ((i*53)%100) + '%'; b.style.background = 'rgba(255,255,255,.10)'; b.style.transform = 'rotate(' + ((i*47)%360) + 'deg)'; box.appendChild(b); } }
  }
  function onScroll(){
    var r = root(); if (!r) return; var sticky = r.querySelector('[data-bsq-sticky]'); if (!sticky) return;
    var top = document.getElementById('bsq-top'), fc = document.getElementById('bsq-finalcta'), y = window.scrollY || 0;
    var past = top ? (y > top.offsetHeight - 80) : (y > 600), near = fc ? (y + window.innerHeight > fc.offsetTop + 40) : false;
    if (past && !near) sticky.classList.add('show'); else sticky.classList.remove('show');
  }
  window.addEventListener('scroll', onScroll, { passive:true });
  function boot(){ if (!root()) return; seed(root()); arm(); beans(); render(); onScroll(); }
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    boot();
    var tries = 0, iv = setInterval(function(){ tries++; boot(); if (tries > 8) clearInterval(iv); }, 400);
    if (window.MutationObserver){ var lastRoot = root(); var mo = new MutationObserver(function(){ var r = root(); if (r && r !== lastRoot){ lastRoot = r; boot(); } }); mo.observe(document.body, { childList:true, subtree:true }); setTimeout(function(){ mo.disconnect(); }, 8000); }
  });
})();

/* ============================================================
   Bean Shipper - Gift Subscription PDP controller (global)
   Runs from bean-shipper.js (layout-level, executes reliably).
   The section's inline <script> does not run inside the theme's
   dynamic-section container (and Recharge re-renders the form),
   so the gift-card live preview, suggested date chips, default
   first-shipment date, note counter, FAQ accordion, reveal
   animations and sticky bar were all dead.
   NOTE: the variant id + selling_plan are hard-rendered into the
   form by Liquid, so the cart payload is correct without JS; every
   behavior below is cosmetic / UX (date default fills a required
   field). Document-level event delegation -> survives section
   injection and app re-render. Pure ASCII only.
   ============================================================ */
(function(){
  if (window.__bsgGift) return; window.__bsgGift = true;
  // Non-ASCII glyphs from the section, escaped:
  var ELLIPSIS = "…";     // horizontal ellipsis used in the empty-note placeholder
  var PV_NOTE_PLACEHOLDER = "Your message appears here as you type" + ELLIPSIS;
  var MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  var DAY = 86400000;

  // Persisted user input + UI state, re-applied via render() after a re-injection.
  var state = { name:null, note:null, date:null, dateInit:false, selChip:-1, box:null };

  function root(){ return document.querySelector('.bsg[data-bsg-root]'); }

  function iso(d){
    var z = new Date(d.getTime() - d.getTimezoneOffset()*60000);
    return z.toISOString().slice(0,10);
  }
  function longDate(v){
    if (!v) return "date TBC";
    var d = new Date(v + "T00:00:00");
    if (isNaN(d)) return "date TBC";
    return d.getDate() + " " + MON[d.getMonth()] + " " + d.getFullYear();
  }
  // The three suggested chip dates (today+5, today+14, first of next month).
  function presets(){
    var now = new Date();
    return [
      new Date(now.getTime() + 5*DAY),
      new Date(now.getTime() + 14*DAY),
      new Date(now.getFullYear(), now.getMonth()+1, 1)
    ];
  }

  // Build the suggested-date chips once per chips node (idempotent via marker attr).
  function buildChips(){
    var r = root(); if (!r) return;
    var chips = r.querySelector('[data-bsg-chips]');
    var dateI = r.querySelector('[data-bsg-date]');
    if (!chips || !dateI) return;
    if (chips.getAttribute('data-bsg-chips-done')) return;
    chips.setAttribute('data-bsg-chips-done','1');
    var ds = presets();
    for (var i=0;i<ds.length;i++){
      (function(d){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bsg-datechip';
        b.setAttribute('data-bsg-chip', iso(d));
        b.innerHTML = '<div class="d">' + d.getDate() + '</div><div class="m">' + MON[d.getMonth()] + '</div>';
        chips.appendChild(b);
      })(ds[i]);
    }
    chips.setAttribute('aria-hidden','false');
  }

  // Default first-shipment date (today+7) + min=today, only if untouched.
  function seedDate(){
    var r = root(); if (!r) return;
    var dateI = r.querySelector('[data-bsg-date]'); if (!dateI) return;
    var today = new Date();
    dateI.setAttribute('min', iso(today));
    if (state.date == null){
      if (dateI.value){ state.date = dateI.value; }
      else { state.date = iso(new Date(today.getTime() + 7*DAY)); }
    }
    state.dateInit = true;
  }

  // Re-apply persisted state to the (possibly re-injected) inputs + preview.
  function render(){
    var r = root(); if (!r) return;
    var nameI = r.querySelector('[data-bsg-name]');
    var dateI = r.querySelector('[data-bsg-date]');
    var noteI = r.querySelector('[data-bsg-note]');
    var pvName = r.querySelector('[data-bsg-pv-name]');
    var pvNote = r.querySelector('[data-bsg-pv-note]');
    var pvDate = r.querySelector('[data-bsg-pv-date]');
    var count = r.querySelector('[data-bsg-count]');
    var chips = r.querySelector('[data-bsg-chips]');

    // Push persisted values back into the live fields.
    if (nameI && state.name != null && nameI.value !== state.name) nameI.value = state.name;
    if (noteI && state.note != null && noteI.value !== state.note) noteI.value = state.note;
    if (dateI && state.date != null && dateI.value !== state.date) dateI.value = state.date;

    // Sync chip selection highlight to current date.
    if (chips){
      var cs = chips.querySelectorAll('.bsg-datechip');
      for (var i=0;i<cs.length;i++){
        var sel = (state.date != null && cs[i].getAttribute('data-bsg-chip') === state.date);
        cs[i].classList.toggle('sel', sel);
      }
    }

    // Live gift-card preview.
    var nv = (nameI && nameI.value.trim()) || (state.name && state.name.trim()) || '';
    if (pvName) pvName.textContent = nv || 'your someone';
    var ov = (noteI && noteI.value.trim()) || (state.note && state.note.trim()) || '';
    if (pvNote) pvNote.textContent = ov || PV_NOTE_PLACEHOLDER;
    var dvSrc = (dateI && dateI.value) || state.date || '';
    if (pvDate) pvDate.textContent = longDate(dvSrc);
    if (count && noteI) count.textContent = noteI.value.length + '/140';
  }

  // Box picker (Two Bags 600g vs One Bag 300g Blend): swaps variant + plan +
  // every price/copy readout. The 2-bag box submits the Recharge prepaid plan;
  // the 1-bag box is a one-time purchase (selling_plan input disabled).
  function applyBox(){
    var r = root(); if (!r) return;
    var boxes = r.querySelectorAll('[data-bsg-box]');
    if (!boxes.length) return;
    var sel = null, i;
    for (i=0;i<boxes.length;i++){
      var match = state.box != null ? (boxes[i].getAttribute('data-vid') === state.box) : boxes[i].classList.contains('sel');
      if (match && !boxes[i].disabled){ sel = boxes[i]; break; }
    }
    if (!sel){ for (i=0;i<boxes.length;i++){ if (!boxes[i].disabled){ sel = boxes[i]; break; } } }
    if (!sel) sel = boxes[0];
    for (i=0;i<boxes.length;i++) boxes[i].classList.toggle('sel', boxes[i] === sel);
    var plan = sel.getAttribute('data-plan') || '';
    var total = parseInt(sel.getAttribute('data-total'),10) || 0;
    var permo = parseInt(sel.getAttribute('data-permo'),10) || 0;
    var bags = parseInt(sel.getAttribute('data-bags'),10) || 2;
    var months = parseInt(r.getAttribute('data-bsg-months'),10) || 3;
    var vi = r.querySelector('[data-bsg-vid]'); if (vi) vi.value = sel.getAttribute('data-vid');
    var pi = r.querySelector('[data-bsg-plan]'); if (pi){ pi.value = plan; pi.disabled = !plan; }
    var es, k;
    es = r.querySelectorAll('[data-bsg-total-n]'); for (k=0;k<es.length;k++) es[k].textContent = String(Math.round(total/100));
    es = r.querySelectorAll('[data-bsg-permo-n]'); for (k=0;k<es.length;k++) es[k].textContent = String(Math.round(permo/100));
    var two = (bags === 2);
    var el;
    el = r.querySelector('[data-bsg-bags-tag]'); if (el) el.textContent = two ? '2 × 300g bags every month' : '1 × 300g bag every month';
    el = r.querySelector('[data-bsg-bags-n]'); if (el) el.textContent = String(months*bags);
    el = r.querySelector('[data-bsg-bags-stat]'); if (el){ el.setAttribute('data-count', String(months*bags)); el.textContent = String(months*bags); }
    el = r.querySelector('[data-bsg-incl-line]'); if (el) el.textContent = two
      ? 'Two bags of fresh-roasted beans each month — 2 × 300g, ' + (months*2) + ' bags in total.'
      : 'One 300g bag of our fresh-roasted house blend each month — ' + months + ' bags in total.';
    el = r.querySelector('[data-bsg-duo-h]'); if (el) el.textContent = two ? 'One blend, one single origin' : 'The house blend, every month';
    el = r.querySelector('[data-bsg-duo-lead]'); if (el) el.textContent = two
      ? 'Each month pairs a crowd-pleasing blend with a single origin to explore — so there’s always a familiar cup and a new story to taste.'
      : 'Every month delivers one 300g bag of our bestseller house blend — the dependable, chocolatey cup that made Bean Shipper.';
    el = r.querySelector('[data-bsg-so-card]'); if (el) el.style.display = two ? '' : 'none';
    el = r.querySelector('[data-bsg-faq-coffee]'); if (el) el.textContent = two
      ? 'Every shipment includes one bestseller blend and one single origin (2 × 300g). The single origin rotates monthly so there’s always something new to discover.'
      : 'Every shipment is one 300g bag of our bestseller house blend — consistent, chocolatey, and easy to love. Prefer variety? Pick the two-bag box.';
  }

  // Count-up for the WHY-GIFT stats (.bsg-stat .v[data-count]).
  function countUp(el){
    if (!el) return;
    var target = parseInt(el.getAttribute('data-count'),10) || 0;
    var dur = 900, t0 = null;
    function tick(now){
      if (t0 == null) t0 = now;
      var p = Math.min(1,(now-t0)/dur), e = 1 - Math.pow(1-p,3);
      el.textContent = Math.round(e*target);
      if (p < 1) requestAnimationFrame(tick); else el.textContent = target;
    }
    requestAnimationFrame(tick);
  }

  // Reveal + count-up via IntersectionObserver (mirrors the inline behavior).
  var io = null;
  function arm(){
    var r = root(); if (!r) return;
    r.classList.add('bsg--anim');
    if (!('IntersectionObserver' in window)){
      r.classList.remove('bsg--anim');
      return;
    }
    if (!io){
      io = new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if (!en.isIntersecting) return;
          en.target.classList.add('in');
          if (en.target.classList.contains('bsg-stat')){
            countUp(en.target.querySelector('[data-count]'));
          }
          io.unobserve(en.target);
        });
      }, { threshold:.18, rootMargin:'0px 0px -8% 0px' });
    }
    var els = r.querySelectorAll('.bsg-reveal:not(.in)');
    for (var j=0;j<els.length;j++) io.observe(els[j]);
  }

  // Sticky add-to-cart bar.
  function onScroll(){
    var r = root(); if (!r) return;
    var sticky = r.querySelector('[data-bsg-sticky]'); if (!sticky) return;
    var top = document.getElementById('bsg-top');
    var y = window.scrollY || 0;
    var past = top ? (y > top.offsetHeight - 80) : (y > 500);
    var nearBottom = (window.innerHeight + y) > (document.body.scrollHeight - 520);
    if (past && !nearBottom) sticky.classList.add('show'); else sticky.classList.remove('show');
  }
  window.addEventListener('scroll', onScroll, { passive:true });

  // ----- Document-level delegation (survives re-injection) -----
  document.addEventListener('click', function(e){
    var r = root(); if (!r || !e.target.closest) return; var el;

    // Box picker chip.
    if ((el = e.target.closest('[data-bsg-box]')) && r.contains(el)){
      if (el.disabled) return;
      state.box = el.getAttribute('data-vid');
      applyBox();
      return;
    }
    // Suggested date chip.
    if ((el = e.target.closest('[data-bsg-chip]')) && r.contains(el)){
      var dval = el.getAttribute('data-bsg-chip');
      state.date = dval;
      var dateI = r.querySelector('[data-bsg-date]'); if (dateI) dateI.value = dval;
      render();
      return;
    }
    // Jump-to-form CTA (final CTA button + sticky bar button).
    if ((el = e.target.closest('[data-bsg-jump]')) && r.contains(el)){
      window.scrollTo({ top:0, behavior:'smooth' });
      setTimeout(function(){
        var rr = root(); if (!rr) return;
        var ni = rr.querySelector('[data-bsg-name]');
        if (ni) ni.focus({ preventScroll:true });
      }, 600);
      return;
    }
    // FAQ accordion.
    if ((el = e.target.closest('.bsg-qa__q')) && r.contains(el)){
      var item = el.closest('.bsg-qa'); if (!item) return;
      var a = item.querySelector('.bsg-qa__a');
      var open = item.classList.toggle('open');
      if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      return;
    }
  }, false);

  // Text/textarea typing -> persist + live preview.
  document.addEventListener('input', function(e){
    var r = root(); if (!r || !e.target.closest) return; var el;
    if ((el = e.target.closest('[data-bsg-name]')) && r.contains(el)){
      state.name = el.value; render(); return;
    }
    if ((el = e.target.closest('[data-bsg-note]')) && r.contains(el)){
      state.note = el.value; render(); return;
    }
    if ((el = e.target.closest('[data-bsg-date]')) && r.contains(el)){
      state.date = el.value;
      // Manual date edit clears any chip selection (mirrors inline behavior).
      var chips = r.querySelector('[data-bsg-chips]');
      if (chips){ var cs = chips.querySelectorAll('.bsg-datechip'); for (var i=0;i<cs.length;i++) cs[i].classList.remove('sel'); }
      render();
      return;
    }
  }, false);

  // The date input fires 'change' (and sometimes only 'change') from the picker.
  document.addEventListener('change', function(e){
    var r = root(); if (!r || !e.target.closest) return; var el;
    if ((el = e.target.closest('[data-bsg-date]')) && r.contains(el)){
      state.date = el.value;
      var chips = r.querySelector('[data-bsg-chips]');
      if (chips){ var cs = chips.querySelectorAll('.bsg-datechip'); for (var i=0;i<cs.length;i++) cs[i].classList.remove('sel'); }
      render();
      return;
    }
  }, false);

  function boot(){
    if (!root()) return;
    seedDate();
    buildChips();
    arm();
    render();
    applyBox();
    onScroll();
  }
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    boot();
    setTimeout(boot, 800);
    setTimeout(boot, 2200);
    if (window.MutationObserver){
      var lastRoot = root(); var mo = new MutationObserver(function(){ var r = root(); if (r && r !== lastRoot){ lastRoot = r; boot(); } });
      mo.observe(document.body, { childList:true, subtree:true });
      setTimeout(function(){ mo.disconnect(); }, 8000);
    }
  });
})();


/* ===== Find My Beans — immersive personality quiz (mounts on #bs-fmb) ===== */
(function () {
  function initFMB() {
    var root = document.getElementById('bs-fmb');
    if (!root || root.getAttribute('data-fmb-ready')) return;
    root.setAttribute('data-fmb-ready', '1');

  var POOL = [], CFG = {};
  try { POOL = JSON.parse(document.getElementById('bs-fmb-products').textContent || '[]'); } catch (e) { POOL = []; }
  try { CFG = JSON.parse(document.getElementById('bs-fmb-config').textContent || '{}'); } catch (e) { CFG = {}; }
  var MARK = CFG.mark || '';

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function cap(s){ s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------- icons (stroke = currentColor) ---------- */
  function ic(paths){ return '<svg width="30" height="30" viewBox="0 0 22 22" aria-hidden="true" style="display:block">' + paths + '</svg>'; }
  function pp(d){ return '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'; }
  var ICONS = {
    espresso: ic(pp('M5 9h11v4a5 5 0 0 1-5 5H10a5 5 0 0 1-5-5V9Z')+pp('M16 10h2.5a2.5 2.5 0 0 1 0 5H16')+pp('M8 3.5c-.6.7-.6 1.3 0 2M11 3c-.6.7-.6 1.3 0 2')),
    pourover: ic(pp('M4 7h14l-2.5 5.5a4 4 0 0 1-3.6 2.3H10.1a4 4 0 0 1-3.6-2.3L4 7Z')+pp('M9 18h4M11 15.8V18')+pp('M11 2.5v2.5')),
    dripbag: ic(pp('M6 5h10v3.5a5 5 0 0 1-5 5 5 5 0 0 1-5-5V5Z')+pp('M4.5 5h13')+pp('M8 13.8 7 19M14 13.8 15 19')),
    frenchpress: ic(pp('M7 8h8v10a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 7 18V8Z')+pp('M6.5 8h9M11 2.5V5m0 0H8.5m2.5 0h2.5')+pp('M11 5v3')),
    fruit: ic(pp('M11 8.5c4 0 5.5 3 5.5 5.5S14.5 20 11 20 5.5 16.5 5.5 14 7 8.5 11 8.5Z')+pp('M11 8.5C11 6 9.5 4 7 4M11 8.5c0-2 1.5-3.5 3.5-3.5')),
    cocoa: ic(pp('M5 6h12v3a6 6 0 0 1-12 0V6Z')+pp('M5 6 7 4h8l2 2M9 9.5l1.5 1.5L9 12.5M13 9.5 11.5 11 13 12.5')),
    nut: ic(pp('M11 4c3 0 5.5 3 5.5 7s-2.5 9-5.5 9-5.5-5-5.5-9S8 4 11 4Z')+pp('M11 4v16M7 9h8M7.5 14h7')),
    floral: ic(pp('M11 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z')+pp('M11 6.5C11 4 12.5 3 14 3.5s1.4 2.6-.5 3.8M11 6.5C11 4 9.5 3 8 3.5s-1.4 2.6.5 3.8')+pp('M11 11.5V20M11 14.5c-2-1-4-.5-5 0M11 14.5c2-1 4-.5 5 0')),
    compass: ic(pp('M11 19.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z')+pp('M14.5 7.5 12.2 12.2 7.5 14.5 9.8 9.8 14.5 7.5Z')),
    anchor: ic(pp('M11 7.5V20M11 7.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z')+pp('M6 8h10M5 13c0 3.5 2.8 6 6 6s6-2.5 6-6M5 13l1.8 1M17 13l-1.8 1'))
  };

  /* ---------- quiz data ---------- */
  var QUESTIONS = [
    { id:'brew', cat:'Ritual', q:'How do you make your morning cup?', sub:"There's no wrong answer — only the one that feels like home.", layout:'cards', options:[
      { id:'espresso', label:'Espresso machine', desc:'Short, intense, no compromise', icon:'espresso', scores:{purist:2,comfort:1} },
      { id:'pourover', label:'Pour-over', desc:'Slow, deliberate, a little ceremony', icon:'pourover', scores:{explorer:2,romantic:1} },
      { id:'dripbag', label:'Drip bag', desc:'Good coffee, anywhere I land', icon:'dripbag', scores:{comfort:2,nightowl:1} },
      { id:'frenchpress', label:'French press', desc:'Full-bodied and unhurried', icon:'frenchpress', scores:{purist:1,comfort:1,explorer:1} }
    ]},
    { id:'flavor', cat:'Palate', q:'Which flavour makes you close your eyes?', sub:"Trust your gut — the cup that you'd reach for twice.", layout:'cards', options:[
      { id:'fruity', label:'Bright & fruity', desc:'Berries, citrus, a little sparkle', icon:'fruit', scores:{explorer:3,romantic:1} },
      { id:'chocolatey', label:'Rich & chocolatey', desc:'Cocoa, caramel, deep and round', icon:'cocoa', scores:{purist:3,comfort:1} },
      { id:'nutty', label:'Smooth & nutty', desc:'Almond, brown sugar, easy-going', icon:'nut', scores:{comfort:3,purist:1} },
      { id:'floral', label:'Delicate & floral', desc:'Jasmine, tea-like, light on its feet', icon:'floral', scores:{romantic:3,explorer:1} }
    ]},
    { id:'roast', cat:'Roast', q:'How dark do you like it?', sub:'From sun-kissed to midnight — pick your shade.', layout:'roast', options:[
      { id:'light', label:'Light', desc:'Tea-like, vivid, acidic', swatch:'#C9A06A', scores:{explorer:2,romantic:2} },
      { id:'medium', label:'Medium', desc:'Balanced, sweet, familiar', swatch:'#8A5333', scores:{comfort:2,romantic:1} },
      { id:'dark', label:'Dark', desc:'Bold, smoky, full force', swatch:'#3A2218', scores:{purist:3,nightowl:1} }
    ]},
    { id:'spirit', cat:'Spirit', q:"At the counter, you're the kind who…", sub:'Be honest — both are a perfectly good way to live.', layout:'cards', options:[
      { id:'surprise', label:'“Surprise me”', desc:'Always chasing the next discovery', icon:'compass', scores:{explorer:3,romantic:1} },
      { id:'reliable', label:'“The usual”', desc:'Found my order, never looked back', icon:'anchor', scores:{comfort:2,purist:2} }
    ]}
  ];
  var N = QUESTIONS.length;

  var PROFILES = {
    explorer: { name:'The Explorer', tagline:'You drink to discover.',
      blurb:"You treat every cup like a postcard from somewhere new — the brighter and stranger, the better. A washed Ethiopian with blueberry and jasmine isn't a novelty to you; it's the point.",
      traits:['Bright','Adventurous','Light roast'], runnerUp:'romantic',
      target:{ roast:'light-roast', flavors:['fruity','floral'] } },
    purist: { name:'The Purist', tagline:'You take it seriously, and straight.',
      blurb:"No frills, no fuss — just a deep, chocolatey shot pulled the way it should be. You know what you like, and you've earned the right to be particular about it.",
      traits:['Bold','Reliable','Dark roast'], runnerUp:'comfort',
      target:{ roast:'dark-roast', flavors:['chocolate','caramel'] } },
    romantic: { name:'The Romantic', tagline:'You drink for the moment, not the rush.',
      blurb:'Coffee is a slow ceremony for you — floral, tea-like, poured by hand while the kettle ticks. You’d rather savour one beautiful cup than gulp three good ones.',
      traits:['Floral','Considered','Light–medium'], runnerUp:'explorer',
      target:{ roast:'light-roast', flavors:['floral','fruity'] } },
    comfort: { name:'The Comfort Seeker', tagline:'You drink for the warm, familiar middle.',
      blurb:"Smooth, nutty, dependable — the cup that feels like a soft landing. You don't need fireworks; you need a brew that's good every single morning without asking much of you.",
      traits:['Smooth','Easy-going','Medium roast'], runnerUp:'purist',
      target:{ roast:'medium-roast', flavors:['nutty','caramel'] } },
    nightowl: { name:'The Night Owl', tagline:'You love the cup, not the jitters.',
      blurb:'Coffee, for you, is comfort after hours — a cocoa-rich, low-caffeine companion for late reading and slow evenings. Proof that good coffee was never really about the buzz.',
      traits:['Mellow','Late-night','Decaf-friendly'], runnerUp:'comfort',
      target:{ roast:'medium-roast', flavors:['chocolate'], decaf:true } }
  };
  var ORDER = ['explorer','purist','romantic','comfort','nightowl'];

  function scoreQuiz(answers){
    var totals = { explorer:0, purist:0, romantic:0, comfort:0, nightowl:0 };
    QUESTIONS.forEach(function(question){
      var chosenId = answers[question.id];
      if (!chosenId) return;
      var opt = null;
      question.options.forEach(function(o){ if (o.id === chosenId) opt = o; });
      if (!opt || !opt.scores) return;
      Object.keys(opt.scores).forEach(function(k){ totals[k] = (totals[k] || 0) + opt.scores[k]; });
    });
    var best = ORDER[0];
    ORDER.forEach(function(k){ if (totals[k] > totals[best]) best = k; });
    return best;
  }

  /* match a real product to a personality */
  function productScore(p, target){
    var s = 0;
    if (p.match_roast === target.roast) s += 3;
    var fl = p.match_flavor || [];
    (target.flavors || []).forEach(function(f){ if (fl.indexOf(f) !== -1) s += 2; });
    if (target.decaf && /decaf/i.test((p.id || '') + ' ' + (p.name || ''))) s += 3;
    return s;
  }
  function bestProduct(profileId, excludeHandle){
    if (!POOL.length) return null;
    var target = PROFILES[profileId].target;
    var best = null, bestScore = -1;
    for (var i = 0; i < POOL.length; i++){
      var p = POOL[i];
      if (excludeHandle && p.id === excludeHandle) continue;
      if (p.available === false) continue;
      var sc = productScore(p, target);
      if (sc > bestScore){ bestScore = sc; best = p; }
    }
    if (!best){ // fallback: first available not excluded
      for (var j = 0; j < POOL.length; j++){ if (POOL[j].id !== excludeHandle && POOL[j].available !== false){ best = POOL[j]; break; } }
    }
    return best || POOL[0];
  }

  function roastLabel(r){ return r === 'light-roast' ? 'Light Roast' : r === 'dark-roast' ? 'Dark Roast' : 'Medium Roast'; }
  function originLabel(p){ var nm = p.name || ''; var m = nm.match(/Ethiopia|Kenya|Rwanda|Burundi|Tanzania|Uganda|Colombia|Brazil|Guatemala|Peru|Costa Rica|El Salvador|Honduras|Panama|Bolivia|Mexico|Indonesia|Sumatra|Java|Flores|Malaysia|Papua New Guinea|Taiwan|Vietnam|India|Yemen/i); if (m) return m[0] + ' · Single Origin'; if (/blend|box|trio|pack|bundle|subscription|signature/i.test(nm)) return 'Bean Shipper Blend'; return 'Bean Shipper · Single Origin'; }
  function noteChips(p){
    var notes = (p.notes || '').split(/[,·•]/).map(function(n){ return n.trim(); }).filter(Boolean);
    if (!notes.length) notes = (p.match_flavor || []).map(cap);
    return notes.slice(0, 3);
  }
  function fmtFormat(p){ var f = p.format || ''; if (!f || /default title/i.test(f)) return 'Whole bean'; return f; }

  /* ---------- state ---------- */
  var step = 'intro', answers = {}, chosen = null, result = null, heroP = null, runnerP = null, runnerProfileId = null, added = false;
  var advTimer = null, brewTimer = null, toastTimer = null;
  var shell = null, els = {};

  function buildShell(){
    root.innerHTML =
      '<div class="stage">' +
        '<div class="progress"><div class="progress__fill"></div></div>' +
        '<div class="topbar"></div>' +
        '<div class="screen"><div class="screen__scroll"></div></div>' +
      '</div>' +
      '<div class="toast"><span class="dot"></span><span class="toast__msg"></span></div>';
    els.stage = root.querySelector('.stage');
    els.fill = root.querySelector('.progress__fill');
    els.topbar = root.querySelector('.topbar');
    els.scroll = root.querySelector('.screen__scroll');
    els.toast = root.querySelector('.toast');
    els.toastMsg = root.querySelector('.toast__msg');
  }

  function showToast(msg){
    els.toastMsg.textContent = msg;
    els.toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ els.toast.classList.remove('show'); }, 2400);
  }

  function brandmark(){
    return '<a class="brandmark" href="' + esc(CFG.homeUrl || '/') + '" aria-label="Bean Shipper home">' +
      (MARK ? '<img src="' + esc(MARK) + '" alt="Bean Shipper">' : '') +
      '<span class="brandmark__txt">Bean Shipper</span></a>';
  }

  function renderTopbar(){
    var isQuestion = typeof step === 'number';
    var showBack = isQuestion || step === 'gate';
    var stepNum = isQuestion ? step + 1 : (step === 'gate' ? N : null);
    var total = (step === 'intro' || step === 'brewing' || step === 'result') ? null : N;
    var html = '<span></span><div class="topbar__meta">';
    if (showBack) html += '<button class="topbtn" data-act="back">← Back</button>';
    if (total != null) html += '<div class="step-count"><b>' + String(stepNum).padStart(2,'0') + '</b> / ' + String(total).padStart(2,'0') + '</div>';
    html += '</div>';
    els.topbar.innerHTML = html;
  }

  function progressPct(){
    if (typeof step === 'number') return ((step + 1) / (N + 2)) * 100;
    if (step === 'gate') return ((N + 1) / (N + 2)) * 100;
    if (step === 'brewing' || step === 'result') return 100;
    return 0;
  }

  /* ---------- screen markup ---------- */
  function introHTML(){
    return '<div class="intro">' +
      '<div class="intro__left stagger">' +
        '<div class="intro__eyebrow">' + esc(CFG.eyebrow) + '</div>' +
        '<h1 class="intro__title">' + (CFG.headline || 'Find My<br><em>beans.</em>') + '</h1>' +
        '<p class="intro__lede">' + esc(CFG.lede) + '</p>' +
        '<div class="intro__cta">' +
          '<button class="btn btn--primary btn--xl" data-act="start">Start the quiz</button>' +
          '<span class="intro__meta">' + N + ' questions · 60 seconds</span>' +
        '</div>' +
      '</div>' +
      '<div class="intro__right">' +
        (CFG.photo ? '<img class="photo" src="' + esc(CFG.photo) + '" alt="Bean Shipper coffee">' : '') +
        (MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="">' : '') +
        '<div class="intro__rquote">Every cup is a postcard. Let’s find yours.</div>' +
      '</div>' +
    '</div>';
  }

  function questionHTML(q, index){
    var isRoast = q.layout === 'roast';
    var cols = q.options.length === 2 ? 'cols-2' : (isRoast ? 'roast' : 'cols-4');
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:38%;right:-9%;bottom:-12%">' : '';
    var head = '<div class="qhead rise">' +
      '<div class="eyebrow-q">Question ' + String(index + 1).padStart(2,'0') + ' · ' + esc(q.cat) + '</div>' +
      '<h2 class="qtitle">' + esc(q.q) + '</h2>' +
      (q.sub ? '<p class="qsub">' + esc(q.sub) + '</p>' : '') +
    '</div>';
    var opts = q.options.map(function(opt, i){
      var letter = String.fromCharCode(65 + i);
      if (isRoast){
        var lit = i + 1, meter = '';
        for (var k = 0; k < q.options.length; k++) meter += '<i class="' + (k < lit ? 'on' : '') + '"></i>';
        return '<button class="opt opt--roast" data-opt="' + esc(opt.id) + '">' +
          '<span class="opt__no">' + letter + '</span>' +
          '<span class="opt__swatch" style="background:' + esc(opt.swatch) + '"></span>' +
          '<span class="opt__label">' + esc(opt.label) + '</span>' +
          '<span class="opt__desc">' + esc(opt.desc) + '</span>' +
          '<span class="roast-meter">' + meter + '</span>' +
        '</button>';
      }
      return '<button class="opt" data-opt="' + esc(opt.id) + '">' +
        '<span class="opt__no">' + letter + '</span>' +
        '<span class="opt__icon">' + (ICONS[opt.icon] || '') + '</span>' +
        '<span class="opt__label">' + esc(opt.label) + '</span>' +
        '<span class="opt__desc">' + esc(opt.desc) + '</span>' +
      '</button>';
    }).join('');
    return '<div class="qwrap">' + wm + head + '<div class="opts ' + cols + ' stagger">' + opts + '</div></div>';
  }

  function gateHTML(){
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:44%;left:-12%;top:-14%;filter:brightness(0) invert(1);opacity:.12">' : '';
    return '<div class="gate">' + wm +
      '<div class="stagger" style="display:contents">' +
        '<div class="gate__bean"><div class="steam"><span></span><span></span><span></span></div>' + (MARK ? '<img src="' + esc(MARK) + '" alt="">' : '') + '</div>' +
        '<h2 class="gate__title">Your blend is <em>ready.</em></h2>' +
        '<p class="gate__sub">Tell us where to send it. We’ll reveal your match on the next screen — and email the brewing notes so you nail the first cup.</p>' +
        '<form class="gate__form" data-act="gate-form" novalidate>' +
          '<input class="gate__input" type="email" inputmode="email" placeholder="you@email.com" aria-label="Email address" autocomplete="email">' +
          '<button class="gate__btn" type="submit">Reveal my match</button>' +
        '</form>' +
        '<div class="gate__err"></div>' +
        '<div class="gate__fine">Fresh roasts &amp; tips. No spam. Unsubscribe anytime.</div>' +
        '<button class="gate__back" data-act="back">← Back to questions</button>' +
      '</div>' +
    '</div>';
  }

  function brewingHTML(){
    return '<div class="brewing">' +
      '<div class="brewing__bean">' + (MARK ? '<img class="ghost" src="' + esc(MARK) + '" alt=""><img class="fill" src="' + esc(MARK) + '" alt="">' : '') + '</div>' +
      '<div class="brewing__label rise">Brewing your match…</div>' +
      '<div class="brewing__dots"><i></i><i></i><i></i></div>' +
    '</div>';
  }

  function resultHTML(){
    var prof = PROFILES[result];
    var p = heroP;
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:30%;left:-8%;bottom:-10%">' : '';
    var traits = prof.traits.map(function(t){ return '<span class="trait">' + esc(t) + '</span>'; }).join('');
    var chips = noteChips(p).map(function(n){ return '<span class="notechip">' + esc(n) + '</span>'; }).join('');
    var runnerHTML = '';
    if (runnerP){
      runnerHTML = '<div class="runnerup">' +
        '<div class="runnerup__thumb">' + (runnerP.image ? '<img src="' + esc(runnerP.image) + '" alt="' + esc(runnerP.name) + '">' : '') + '</div>' +
        '<div class="runnerup__txt"><span class="runnerup__label">Also worth a try</span>' +
        '<span class="runnerup__name">' + esc(runnerP.name) + ' · <b>' + esc(PROFILES[runnerProfileId].name) + '</b></span></div>' +
      '</div>';
    }
    return '<div class="result">' + wm +
      '<div class="result__grid">' +
        '<div class="stagger">' +
          '<div class="result__eyebrow">Your coffee personality</div>' +
          '<h1 class="result__name">' + esc(prof.name) + '</h1>' +
          '<p class="result__tagline">' + esc(prof.tagline) + '</p>' +
          '<div class="result__traits">' + traits + '</div>' +
          '<p class="result__blurb">' + esc(prof.blurb) + '</p>' +
          '<div class="result__actions">' +
            '<button class="btn btn--secondary" data-act="retake">Retake quiz</button>' +
            '<button class="btn btn--ghost" data-act="share">Share result</button>' +
          '</div>' + runnerHTML +
        '</div>' +
        '<div class="rise" style="animation-delay:calc(2 * var(--anim-stagger))">' +
          '<div class="prodcard">' +
            '<div class="prodcard__media"><span class="prodcard__tag">Your match</span>' +
              (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.name) + '">' : '') + '</div>' +
            '<div class="prodcard__body">' +
              '<div class="prodcard__origin">' + esc(originLabel(p)) + '</div>' +
              '<h3 class="prodcard__name">' + esc(p.name) + '</h3>' +
              '<div class="notechips">' + chips + '</div>' +
              '<div class="prodcard__spec">' +
                '<div><div class="k">Roast</div><div class="v">' + esc(roastLabel(p.match_roast)) + '</div></div>' +
                '<div><div class="k">Format</div><div class="v">' + esc(fmtFormat(p)) + '</div></div>' +
              '</div>' +
              '<div class="prodcard__foot">' +
                '<div class="prodcard__price">' + esc(p.price_formatted) + '<small>Free shipping from RM80</small></div>' +
                '<button class="btn btn--primary" data-act="add"' + (added ? ' disabled' : '') + '>' + (added ? 'Added ✓' : 'Add to cart') + '</button>' +
              '</div>' +
              '<a class="prodcard__viewbag' + (added ? ' show' : '') + '" href="' + esc(CFG.cartUrl || '/cart') + '">View bag →</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ---------- render ---------- */
  function render(){
    var dark = step === 'gate' || step === 'brewing';
    els.stage.className = 'stage' + (dark ? ' is-dark' : '');
    els.fill.style.width = progressPct() + '%';
    renderTopbar();
    var html;
    if (step === 'intro') html = introHTML();
    else if (typeof step === 'number') html = questionHTML(QUESTIONS[step], step);
    else if (step === 'gate') html = gateHTML();
    else if (step === 'brewing') html = brewingHTML();
    else html = resultHTML();
    els.scroll.innerHTML = html;
    els.scroll.scrollTop = 0;
    bindScreen();
  }

  function bindScreen(){
    var startBtn = els.scroll.querySelector('[data-act="start"]');
    if (startBtn) startBtn.addEventListener('click', function(){ step = 0; render(); });

    var opts = els.scroll.querySelectorAll('.opt');
    if (opts.length){
      opts.forEach(function(btn){
        btn.addEventListener('click', function(){ choose(btn.getAttribute('data-opt'), btn); });
      });
    }

    var form = els.scroll.querySelector('[data-act="gate-form"]');
    if (form){
      var input = form.querySelector('.gate__input');
      setTimeout(function(){ if (input) input.focus(); }, 500);
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var v = (input.value || '').trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        var err = els.scroll.querySelector('.gate__err');
        if (!ok){ input.classList.add('is-error'); if (err) err.textContent = 'Please enter a valid email so we can send your match.'; return; }
        input.classList.remove('is-error'); if (err) err.textContent = '';
        captureEmail(v);
        toBrewing();
      });
      input.addEventListener('input', function(){ input.classList.remove('is-error'); var err = els.scroll.querySelector('.gate__err'); if (err) err.textContent = ''; });
    }

    var retake = els.scroll.querySelector('[data-act="retake"]');
    if (retake) retake.addEventListener('click', doRetake);
    var shareB = els.scroll.querySelector('[data-act="share"]');
    if (shareB) shareB.addEventListener('click', doShare);
    var addB = els.scroll.querySelector('[data-act="add"]');
    if (addB) addB.addEventListener('click', addToCart);

    var backB = els.topbar.querySelector('[data-act="back"]');
    if (backB) backB.addEventListener('click', goBack);
    var backB2 = els.scroll.querySelector('[data-act="back"]');
    if (backB2) backB2.addEventListener('click', goBack);
  }

  function choose(optId, btn){
    if (chosen) return;
    var q = QUESTIONS[step];
    chosen = optId;
    answers[q.id] = optId;
    if (btn) btn.classList.add('is-chosen');
    clearTimeout(advTimer);
    advTimer = setTimeout(function(){
      chosen = null;
      if (step < N - 1) step = step + 1; else step = 'gate';
      render();
    }, 360);
  }

  function goBack(){
    clearTimeout(advTimer); chosen = null;
    if (step === 'gate') step = N - 1;
    else if (typeof step === 'number' && step > 0) step = step - 1;
    else if (step === 0) step = 'intro';
    render();
  }

  function toBrewing(){
    result = scoreQuiz(answers);
    heroP = bestProduct(result, null);
    runnerProfileId = PROFILES[result].runnerUp;
    runnerP = bestProduct(runnerProfileId, heroP ? heroP.id : null);
    step = 'brewing'; render();
    clearTimeout(brewTimer);
    brewTimer = setTimeout(function(){ step = 'result'; render(); }, 2150);
  }

  function doRetake(){
    clearTimeout(advTimer); clearTimeout(brewTimer);
    answers = {}; chosen = null; result = null; heroP = null; runnerP = null; added = false;
    step = 'intro'; render();
  }

  function doShare(){
    var txt = 'I’m “' + (result ? PROFILES[result].name : 'a coffee lover') + '” — find your Bean Shipper match.';
    if (navigator.share){ navigator.share({ title: 'Bean Shipper Taste Profile', text: txt, url: location.href }).catch(function(){}); }
    else if (navigator.clipboard){ navigator.clipboard.writeText(location.href).then(function(){ showToast('Result link copied'); }).catch(function(){ showToast('Result link copied'); }); }
    else showToast('Result link copied');
  }

  function captureEmail(email){
    try {
      var f = document.getElementById('bs-fmb-capture');
      var inp = document.getElementById('bs-fmb-capture-email');
      if (f && inp) { inp.value = email; try { f.target = 'bs-fmb-sink'; } catch (e) {} f.submit(); }
    } catch (e) {}
  }

  function addToCart(){
    if (added || !heroP) return;
    fetch(bsUrl('cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: heroP.variant_id, quantity: 1 })
    }).then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); }).then(function(){
      added = true;
      var btn = els.scroll.querySelector('[data-act="add"]');
      if (btn){ btn.textContent = 'Added ✓'; btn.setAttribute('disabled', 'disabled'); }
      var vb = els.scroll.querySelector('.prodcard__viewbag');
      if (vb) vb.classList.add('show');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      showToast(heroP.name + ' added to cart');
    }).catch(function(){ showToast('Could not add — try again'); });
  }

  /* ---------- mount ---------- */
  document.documentElement.classList.add('bs-fmb-lock');
  buildShell();
  render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFMB);
  else initFMB();
  document.addEventListener('shopify:section:load', initFMB);
})();

/* ============================================================
   Bean Shipper - Gift LANDING page controller (/pages/gift, .bsgl)
   Port of the Claude Design "Gift Subscription" prototype JS:
   hero stagger, scroll reveals, count-ups, occasions, FAQ,
   sticky bar, and the 3-step gift builder with live card preview.
   The builder's final CTA does a REAL /cart/add (One Bag 300g
   variant per duration, or a real Gift Card variant) and opens
   the cart drawer. Lives here because section inline <script>
   does not execute in this theme.
   ============================================================ */
(function () {
  if (window.__bsgl) return; window.__bsgl = true;

  function root() { return document.querySelector('[data-bsgl]'); }

  var PLANS = [], CARDS = [];
  var st = { mode: 'plan', planId: '6mo', amountIdx: 0, to: '', from: '', msg: '', date: '', email: '', step: 0, busy: false };

  function fmtRM(n) { return 'RM' + Number(n).toLocaleString('en-MY'); }
  function plan() { for (var i = 0; i < PLANS.length; i++) if (PLANS[i].id === st.planId) return PLANS[i]; return PLANS[1] || PLANS[0]; }
  function card() { return CARDS[st.amountIdx] || CARDS[0]; }
  function total() { return st.mode === 'card' ? (card() ? card().amount : 0) : (plan() ? plan().price : 0); }
  function variantId() { return st.mode === 'card' ? (card() && card().variant) : (plan() && plan().variant); }

  /* ---------- page behaviors ---------- */
  function boot() {
    var r = root(); if (!r || r.getAttribute('data-bsgl-ready')) return;
    r.setAttribute('data-bsgl-ready', '1');
    try { PLANS = JSON.parse(r.querySelector('[data-bsgl-plans]').textContent || '[]'); } catch (e) { PLANS = []; }
    try { CARDS = JSON.parse(r.querySelector('[data-bsgl-cards]').textContent || '[]'); } catch (e) { CARDS = []; }
    // default gift-card amount: the middle one (design default RM100)
    if (CARDS.length) { st.amountIdx = Math.min(1, CARDS.length - 1); }

    setTimeout(function () { r.classList.add('is-hero-in'); }, 120);

    // reveals
    var els = Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-reveal]'));
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); }
    else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    // count-ups
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-count]')).forEach(function (el) {
      var to = parseInt(el.getAttribute('data-bsgl-count'), 10) || 0;
      if (!('IntersectionObserver' in window)) { el.textContent = to.toLocaleString('en-MY'); return; }
      var cio = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return;
        cio.disconnect();
        var t0 = performance.now(), dur = 1400;
        function tick(t) {
          var p = Math.min(1, (t - t0) / dur), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * eased).toLocaleString('en-MY');
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.4 });
      cio.observe(el);
    });

    // occasions
    var occLine = r.querySelector('[data-bsgl-occ-line]');
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-occ]')).forEach(function (b) {
      function act() {
        Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-occ]')).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (occLine) occLine.textContent = '“' + b.getAttribute('data-bsgl-occ') + '”';
      }
      b.addEventListener('mouseenter', act);
      b.addEventListener('focus', act);
      b.addEventListener('click', function () { act(); openGB(null); });
    });

    // FAQ (one open at a time)
    Array.prototype.slice.call(r.querySelectorAll('.bsgl-faq__q')).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.bsgl-faq'); if (!item) return;
        var was = item.classList.contains('is-open');
        Array.prototype.slice.call(r.querySelectorAll('.bsgl-faq')).forEach(function (f) {
          f.classList.remove('is-open');
          var b = f.querySelector('.bsgl-faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!was) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });

    // sticky bar
    var bar = r.querySelector('[data-bsgl-bar]');
    if (bar) {
      var onScroll = function () {
        var y = window.scrollY || 0;
        var nearEnd = y + window.innerHeight > document.body.scrollHeight - 700;
        bar.classList.toggle('is-on', y > window.innerHeight * 0.9 && !nearEnd);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // builder triggers
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-open]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); openGB(b.getAttribute('data-bsgl-open') || null); });
    });
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-plan-card]')).forEach(function (cardEl) {
      cardEl.addEventListener('click', function () { openGB(cardEl.getAttribute('data-bsgl-plan-card')); });
    });
    var ov = r.querySelector('[data-bsgl-overlay]');
    if (ov) ov.addEventListener('click', function (e) { if (e.target === ov) closeGB(); });
    var closeBtn = r.querySelector('[data-bsgl-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeGB);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGB(); });

    var backB = r.querySelector('[data-bsgl-back]');
    if (backB) backB.addEventListener('click', function () { if (st.step > 0) { st.step--; renderGB(); } });
    var nextB = r.querySelector('[data-bsgl-next]');
    if (nextB) nextB.addEventListener('click', nextStep);

    ['to', 'from', 'msg', 'date', 'email'].forEach(function (k) {
      var inp = r.querySelector('[data-bsgl-' + k + ']');
      if (inp) inp.addEventListener('input', function () { st[k] = inp.value; inp.classList.remove('is-err'); preview(); });
    });
  }

  /* ---------- builder ---------- */
  function openGB(initial) {
    var r = root(); if (!r) return;
    st.step = 0; st.busy = false;
    if (initial === 'card') { st.mode = 'card'; }
    else { st.mode = 'plan'; if (initial) st.planId = initial; }
    var ov = r.querySelector('[data-bsgl-overlay]'); if (ov) ov.classList.add('is-open');
    renderGB();
  }
  function closeGB() {
    var r = root(); if (!r) return;
    var ov = r.querySelector('[data-bsgl-overlay]'); if (ov) ov.classList.remove('is-open');
  }

  function planRows() {
    if (st.mode === 'card') {
      return CARDS.map(function (c, i) {
        return '<button type="button" class="bsgl-gbplan' + (i === st.amountIdx ? ' is-sel' : '') + '" data-bsgl-row="' + i + '">' +
          '<span class="bsgl-gbplan__radio"></span>' +
          '<span><span class="bsgl-gbplan__name">' + fmtRM(c.amount) + ' gift card</span>' +
          '<div class="bsgl-gbplan__sub">They choose the plan, roast and start date</div></span>' +
          '<span class="bsgl-gbplan__price">' + fmtRM(c.amount) + '</span></button>';
      }).join('');
    }
    return PLANS.map(function (p) {
      return '<button type="button" class="bsgl-gbplan' + (p.id === st.planId ? ' is-sel' : '') + '" data-bsgl-row="' + p.id + '">' +
        '<span class="bsgl-gbplan__radio"></span>' +
        '<span><span class="bsgl-gbplan__name">' + p.name + '</span>' +
        // 13 Aug (Kai): gift prices lead per shipment everywhere. The prominent
        // slot carries the per-month figure; the prepaid total moves to the
        // sub-line as "billed once", matching the gift page's plan cards.
        // Inline unit style so this stays a one-file change — .bsgl-gbplan__price
        // has no .u rule of its own (that pattern lives on .bsgl-plan__price).
        '<div class="bsgl-gbplan__sub">' + p.term + ' · ' + fmtRM(p.price) + ' billed once' + (p.save ? ' · save ' + fmtRM(p.save) : '') + '</div></span>' +
        '<span class="bsgl-gbplan__price">' + fmtRM(p.perMonth) + '<span style="font-size:.62em;font-weight:400;opacity:.65">/mo</span></span></button>';
    }).join('');
  }

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function renderGB() {
    var r = root(); if (!r) return;
    // steps visibility
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-step]')).forEach(function (el) {
      el.hidden = (parseInt(el.getAttribute('data-bsgl-step'), 10) !== st.step);
    });
    // dots
    Array.prototype.slice.call(r.querySelectorAll('[data-bsgl-dot]')).forEach(function (d, i) {
      d.classList.toggle('is-done', st.step >= i);
    });
    // step 0
    var kick = r.querySelector('[data-bsgl-step0-kicker]');
    if (kick) kick.textContent = 'Step 1 of 3 — ' + (st.mode === 'card' ? 'Choose an amount' : 'Choose their plan');
    var rows = r.querySelector('[data-bsgl-plan-rows]');
    if (rows && st.step === 0) {
      rows.innerHTML = planRows();
      Array.prototype.slice.call(rows.querySelectorAll('[data-bsgl-row]')).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-bsgl-row');
          if (st.mode === 'card') st.amountIdx = parseInt(v, 10) || 0; else st.planId = v;
          renderGB();
        });
      });
    }
    // date label
    var dl = r.querySelector('[data-bsgl-datelabel]');
    if (dl) dl.textContent = st.mode === 'card' ? 'Send the gift card on' : 'First box ships on';
    // Delivery line from the order total (2 Oct 2026; rate-checked against the general shipping
    // profile: Peninsular free from RM80, Sabah/Sarawak/Labuan from RM150, Singapore from RM200).
    // Gift cards are emailed.
    function shipLine() {
      if (st.mode === 'card') return 'By email';
      var t = total();
      if (t >= 200) return 'Free in Malaysia and Singapore';
      if (t >= 150) return 'Free anywhere in Malaysia';
      if (t >= 80) return 'Free in Peninsular Malaysia';
      return 'Calculated at checkout';
    }
    // summary
    if (st.step === 2) {
      var label = st.mode === 'card' ? ('Gift card · ' + fmtRM(card().amount)) : (plan().name + ' · ' + plan().term);
      var sum = r.querySelector('[data-bsgl-summary]');
      if (sum) sum.innerHTML =
        '<div class="bsgl-sumrow"><span>Gift</span><span class="v">' + esc(label) + '</span></div>' +
        '<div class="bsgl-sumrow"><span>To</span><span class="v">' + esc(st.to || '—') + '</span></div>' +
        '<div class="bsgl-sumrow"><span>From</span><span class="v">' + esc(st.from || '—') + '</span></div>' +
        '<div class="bsgl-sumrow"><span>' + (st.mode === 'card' ? 'Sends on' : 'First box') + '</span><span class="v">' + esc(st.date || 'As soon as possible') + '</span></div>' +
        '<div class="bsgl-sumrow"><span>Delivery</span><span class="v">' + shipLine() + '</span></div>' +
        '<div class="bsgl-sumrow is-total"><span>Total, once</span><span class="v">' + fmtRM(total()) + '</span></div>';
    }
    // foot
    var backB = r.querySelector('[data-bsgl-back]');
    if (backB) {
      if (st.step > 0) { backB.textContent = '← Back'; backB.style.opacity = ''; }
      else { backB.innerHTML = 'Total: <strong>' + fmtRM(total()) + '</strong>'; backB.style.opacity = '.4'; }
    }
    var nextB = r.querySelector('[data-bsgl-next]');
    if (nextB) {
      nextB.disabled = !!st.busy;
      nextB.textContent = st.busy ? 'Adding…' : (st.step === 2 ? 'Send the gift · ' + fmtRM(total()) : 'Continue →');
    }
    preview();
  }

  function preview() {
    var r = root(); if (!r) return;
    var n = r.querySelector('[data-bsgl-pv-name]'); if (n) n.textContent = st.to.trim() || 'Someone lovely';
    var m = r.querySelector('[data-bsgl-pv-msg]'); if (m) m.textContent = st.msg.trim() ? '“' + st.msg.trim() + '”' : '“Months of very good mornings, starting now.”';
    var f = r.querySelector('[data-bsgl-pv-from]'); if (f) f.textContent = st.from.trim() || 'You';
    var c = r.querySelector('[data-bsgl-msgcount]'); if (c) c.textContent = st.msg.length + ' / 140';
  }

  function nextStep() {
    var r = root(); if (!r) return;
    if (st.step === 1) {
      var bad = false;
      if (!st.to.trim()) { var ti = r.querySelector('[data-bsgl-to]'); if (ti) ti.classList.add('is-err'); bad = true; }
      if (!st.from.trim()) { var fi = r.querySelector('[data-bsgl-from]'); if (fi) fi.classList.add('is-err'); bad = true; }
      if (bad) return;
    }
    if (st.step < 2) { st.step++; renderGB(); return; }
    sendGift();
  }

  function sendGift() {
    if (st.busy) return;
    var vid = variantId();
    var r = root();
    if (!vid || !r) { closeGB(); return; }
    st.busy = true; renderGB();
    // Submit through a real [data-bs-add] form so the theme's delegated
    // AJAX-cart handler performs the add AND opens the cart drawer —
    // the same battle-tested path the PDPs use.
    var f = document.createElement('form');
    f.setAttribute('data-bs-add', '');
    f.setAttribute('action', '/cart/add');
    f.setAttribute('method', 'post');
    f.style.display = 'none';
    function inp(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
    inp('id', vid);
    inp('quantity', '1');
    inp('properties[Recipient]', st.to.trim());
    inp('properties[From]', st.from.trim());
    if (st.msg.trim()) inp('properties[Gift note]', st.msg.trim());
    if (st.date) inp(st.mode === 'card' ? 'properties[Send on]' : 'properties[First shipment]', st.date);
    if (st.email.trim()) inp('properties[Recipient email]', st.email.trim());
    r.appendChild(f);
    if (f.requestSubmit) f.requestSubmit(); else f.submit();
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); st.busy = false; closeGB(); }, 400);
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    boot();
    setTimeout(boot, 800);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { boot(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
  });
})();

/* =================================================================
   BS HOMEPAGE V2 (__bshp) — reveals, count-ups, parallax, marquee.
   Section: index__bean-shipper-v2. Inline section scripts are inert
   in this theme, so all behaviour lives here, booted by marker attr.
   ================================================================= */
(function () {
  if (window.__bshp) return; window.__bshp = true;

  function boot() {
    var root = document.querySelector('[data-bshp-root]');
    if (!root || root.hasAttribute('data-bshp-ready')) return;
    root.setAttribute('data-bshp-ready', '1');
    root.classList.add('bshp-js');

    /* Scroll reveals */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.slice.call(root.querySelectorAll('[data-bshp-reveal]')).forEach(function (el) { io.observe(el); });

    /* Count-up stats */
    function runCounter(el) {
      var target = parseFloat(el.getAttribute('data-bshp-count'));
      if (isNaN(target)) return;
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var start = null, dur = 1600;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCounter(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    Array.prototype.slice.call(root.querySelectorAll('[data-bshp-count]')).forEach(function (el) { cio.observe(el); });

    /* Parallax — bean watermarks + framed photo */
    var pxEls = Array.prototype.slice.call(root.querySelectorAll('[data-bshp-parallax]'));
    var pxImgs = Array.prototype.slice.call(root.querySelectorAll('[data-bshp-parallax-img]'));
    if (pxEls.length || pxImgs.length) {
      var queued = false;
      var apply = function () {
        queued = false;
        var vh = window.innerHeight;
        pxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var c = r.top + r.height / 2 - vh / 2;
          el.style.transform = 'translateY(' + (-c * parseFloat(el.getAttribute('data-bshp-parallax'))).toFixed(1) + 'px)';
        });
        pxImgs.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var c = r.top + r.height / 2 - vh / 2;
          el.style.transform = 'scale(1.12) translateY(' + (-c * parseFloat(el.getAttribute('data-bshp-parallax-img'))).toFixed(1) + 'px)';
        });
      };
      var queue = function () { if (!queued) { queued = true; requestAnimationFrame(apply); } };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      queue();
    }

    /* Route line — terminate the dotted route exactly at the spinning stamp,
       at every viewport. The route SVG stretches (preserveAspectRatio none,
       viewBox 1440x720), so convert the stamp's pixel centre into viewBox
       units and rewrite the path end. */
    var routeEnd = { x: 1262, y: 460 };
    function alignRoute() {
      var hero = root.querySelector('.bshp-hero');
      var line = root.querySelector('.bshp-sea__route-line');
      var stamp = root.querySelector('.bshp-hero__stamp');
      if (!hero || !line || !stamp) return;
      var hr = hero.getBoundingClientRect();
      var sr = stamp.getBoundingClientRect();
      if (!hr.width || !sr.width) return;
      var cx = (sr.left + sr.width / 2 - hr.left) / hr.width * 1440;
      var cy = (sr.top + sr.height / 2 - hr.top) / hr.height * 720;
      routeEnd.x = Math.round(cx * 10) / 10;
      routeEnd.y = Math.round(cy * 10) / 10;
      line.setAttribute('d', 'M-40,340 C320,160 840,120 ' + routeEnd.x + ',' + routeEnd.y);
    }
    alignRoute();
    setTimeout(alignRoute, 600);
    window.addEventListener('resize', alignRoute);

    /* Travelling dot — rAF-driven along the same cubic bezier. SMIL
       animateMotion is paused by iOS Safari in Low Power Mode and ignores
       path changes after start, so the position is computed in JS. */
    var dot = root.querySelector('.bshp-sea__route-dot');
    if (dot) {
      var DOT_DUR = 12000;
      var dotStart = null;
      var dotTick = function (ts) {
        if (dotStart === null) dotStart = ts;
        var t = ((ts - dotStart) % DOT_DUR) / DOT_DUR;
        var u = 1 - t;
        var x = u * u * u * -40 + 3 * u * u * t * 320 + 3 * u * t * t * 840 + t * t * t * routeEnd.x;
        var y = u * u * u * 340 + 3 * u * u * t * 160 + 3 * u * t * t * 120 + t * t * t * routeEnd.y;
        dot.setAttribute('cx', x.toFixed(1));
        dot.setAttribute('cy', y.toFixed(1));
        requestAnimationFrame(dotTick);
      };
      requestAnimationFrame(dotTick);
    }

    /* Marquee — duplicate the group so the loop is seamless */
    var track = root.querySelector('[data-bshp-marquee]');
    if (track && !track.hasAttribute('data-bshp-cloned')) {
      track.setAttribute('data-bshp-cloned', '1');
      var group = track.querySelector('.bshp-marquee__group');
      if (group) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    boot();
    setTimeout(boot, 800);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { boot(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
  });
})();

/* ============================================================
   BS-CRO-MODULES v1 (21/7/26)
   Appended by the CRO build. Marker: window.__bsCroModules
   — assert this marker before ever appending again.
   1) Free-shipping progress nudge in the cart drawer.
      (The drawer foot is patched, not re-rendered, by the ajax
      cart, and snippet-inline <script> is inert because the
      drawer hydrates via innerHTML — so this must live here.)
   2) Mobile sticky add-to-bag for the DEFAULT product template.
      product__shipper-classic (.bsc-sticky) and
      product__bs-default-v2 (.bspp-sticky) already have their own.
   ============================================================ */
(function () {
  'use strict';
  if (window.__bsCroModules) return;
  window.__bsCroModules = 'v1';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function retry(fn, times, gap) {
    var n = 0;
    var iv = setInterval(function () { fn(); if (++n >= times) clearInterval(iv); }, gap || 300);
  }
  function money(t) {
    var n = parseFloat(String(t == null ? '' : t).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  /* ---------- 1. Cart drawer — free-shipping progress ---------- */
  var FREE_SHIP_RM = 80; /* Peninsula Malaysia threshold */
  /* 7 Oct 2026: the drawer root may override the threshold and wording per market
     (bean-shipper-cart-drawer.liquid sets data-bs-freeship / data-bs-ship-label /
     data-bs-ship-subs-free from localization.country): Singapore is RM200, and its
     subscriptions pay the courier too. Defaults keep the Malaysian behaviour. */
  function shipCfg() {
    var root = document.querySelector('[data-bs-cart-drawer]');
    var rm = root ? parseFloat(root.getAttribute('data-bs-freeship')) : NaN;
    return {
      rm: (isNaN(rm) || rm <= 0) ? FREE_SHIP_RM : rm,
      label: (root && root.getAttribute('data-bs-ship-label')) || 'free Peninsula shipping',
      subsFree: !(root && root.getAttribute('data-bs-ship-subs-free') === '0')
    };
  }

  function paintShip() {
    var ship = document.querySelector('[data-bs-cart-ship]');
    var sub = document.querySelector('[data-bs-cart-drawer] [data-bs-cart-subtotal]');
    if (!ship || !sub) return;
    /* 12 Aug CRO audit: subscriptions ship free within Malaysia every cycle —
       an all-subscription cart must never see the RM80 progress bar. Mirrors
       the same guard in bean-shipper-cart-drawer.liquid. */
    /* 25 Sep 2026: read the purchase type from the drawer's own line tags first.
       Liquid and BS.cart's render() both print a Subscription / One-time tag on
       every line before this runs, while BeanShipper.cart.state is still empty on
       page load (and one step stale inside render()) - that painted "RM X from
       free Peninsula shipping" over all-subscription carts. State is the fallback. */
    var body = document.querySelector('[data-bs-cart-drawer] [data-bs-cart-body]');
    var nSubTags = body ? body.querySelectorAll('.cart-item__sub-tag').length : 0;
    var nOneTags = body ? body.querySelectorAll('.cart-item__onetime-tag').length : 0;
    var allSubs;
    if (nSubTags + nOneTags > 0) {
      allSubs = nOneTags === 0;
    } else {
      var st = window.BeanShipper && window.BeanShipper.cart && window.BeanShipper.cart.state;
      var items = (st && st.items) || [];
      allSubs = items.length > 0 && items.every(function (i) { return i.selling_plan_allocation; });
    }
    /* East MY / Singapore thresholds are one-time rules; an all-subscription cart
       shows its own note ([data-bs-ship-note] in bean-shipper-cart-drawer.liquid). */
    var notes = document.querySelectorAll('[data-bs-cart-drawer] [data-bs-ship-note]');
    for (var k = 0; k < notes.length; k++) {
      notes[k].hidden = notes[k].getAttribute('data-bs-ship-note') === 'sub' ? !allSubs : allSubs;
    }
    var cfg = shipCfg();
    if (allSubs && cfg.subsFree) {
      ship.className = 'cart__foot-ship cart__foot-ship--won';
      ship.innerHTML = '✓ Your subscription ships free within Malaysia';
      return;
    }
    var total = money(sub.textContent);
    var remain = cfg.rm - total;
    if (remain > 0.009) {
      var pct = Math.max(0, Math.min(100, Math.round((total / cfg.rm) * 100)));
      ship.className = 'cart__foot-ship';
      ship.innerHTML = 'You’re <strong>RM ' + (Math.abs(remain - Math.round(remain)) < 0.005 ? String(Math.round(remain)) : remain.toFixed(2)) +
        '</strong> from ' + cfg.label + '<div class="cart__foot-ship-bar"><span style="width:' + pct + '%"></span></div>';
    } else {
      ship.className = 'cart__foot-ship cart__foot-ship--won';
      ship.innerHTML = '✓ You’ve unlocked ' + cfg.label;
    }
  }
  /* 12 Aug CRO audit: the ajax drawer refresh replaces the foot node, orphaning
     the MutationObserver below — expose the painter so BS.cart's render() can
     call it after every foot patch. */
  window.__bsPaintShip = paintShip;

  function initShip() {
    var sub = document.querySelector('[data-bs-cart-drawer] [data-bs-cart-subtotal]');
    if (!sub || sub.getAttribute('data-bs-ship-bound')) return;
    sub.setAttribute('data-bs-ship-bound', '1');
    paintShip();
    try {
      new MutationObserver(paintShip).observe(sub, { childList: true, characterData: true, subtree: true });
    } catch (e) {}
  }

  /* ---------- 2. Mobile sticky add-to-bag (default PDP only) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-bs-sticky-buy]');
    if (!bar || bar.getAttribute('data-bs-sticky-bound')) return;
    var addBtn = document.querySelector('[data-bs-pdp-add]');
    /* offsetParent null => hidden (sold out, back-in-stock form showing) */
    if (!addBtn || addBtn.offsetParent === null) return;
    bar.setAttribute('data-bs-sticky-bound', '1');

    var sBtn = bar.querySelector('[data-bs-sticky-add]');
    if (sBtn) {
      sBtn.addEventListener('click', function (ev) { ev.preventDefault(); addBtn.click(); });
    }

    var dstPrice = bar.querySelector('[data-bs-sticky-price]');
    function syncPrice() {
      if (!dstPrice) return;
      var m = String(addBtn.textContent || '').match(/RM\s?[\d.,]+/);
      if (m) dstPrice.textContent = m[0];
    }
    syncPrice();
    try {
      new MutationObserver(syncPrice).observe(addBtn, { childList: true, characterData: true, subtree: true });
    } catch (e) {}

    if (!('IntersectionObserver' in window)) return;
    try {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (scrolledPast) bar.classList.add('is-on');
          else bar.classList.remove('is-on');
        }
      }, { threshold: 0 }).observe(addBtn);
    } catch (e) {}
  }

  function boot() { initShip(); initSticky(); }
  ready(boot);
  retry(boot, 20, 300);
})();

/* ============================================================
   BS-DRIP v1 (21/7/26) — Drip Pack PDP behaviour.
   Marker: window.__bsDrip. Boots on [data-bsdp].
   Ported from the Claude Design DCLogic component; section-inline
   <script> is unreliable in this theme, so it lives here.
   ============================================================ */
(function () {
  'use strict';
  if (window.__bsDrip) return;
  window.__bsDrip = 'v1';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function boot() {
    var root = document.querySelector('[data-bsdp]');
    if (!root || root.getAttribute('data-bsdp-bound')) return;
    root.setAttribute('data-bsdp-bound', '1');

    /* ---------- gallery ---------- */
    var stage = root.querySelector('[data-bsdp-stage]');
    var thumbs = root.querySelectorAll('[data-bsdp-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-bsdp-thumb');
        if (stage && src) stage.src = src;
        Array.prototype.forEach.call(thumbs, function (o) { o.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });

    /* ---------- pack / variant selection ---------- */
    var packs = root.querySelectorAll('[data-bsdp-pack]');
    var idInput = root.querySelector('[data-bs-variant-id]');
    var priceEls = root.querySelectorAll('[data-bsdp-price]');
    var ctaPriceEls = root.querySelectorAll('[data-bsdp-ctaprice]');
    var perCup = root.querySelector('[data-bsdp-percup]');
    var packMeta = root.querySelector('[data-bsdp-packmeta]');
    var statSachets = root.querySelector('[data-bsdp-statsachets]');
    var stickyMeta = root.querySelector('[data-bsdp-stickymeta]');

    function applyPack(btn) {
      if (!btn) return;
      var id = btn.getAttribute('data-bsdp-pack');
      var fmt = btn.getAttribute('data-price-fmt') || '';
      var cup = btn.getAttribute('data-percup') || '';
      var sach = btn.getAttribute('data-sachets') || '';
      var label = (btn.querySelector('.bsdp__pack-label') || {}).textContent || '';

      if (idInput && id) idInput.value = id;
      Array.prototype.forEach.call(priceEls, function (e) { e.textContent = fmt; });
      Array.prototype.forEach.call(ctaPriceEls, function (e) { e.textContent = fmt; });
      if (perCup) perCup.textContent = cup ? (cup + ' / cup') : '';
      if (packMeta) packMeta.textContent = sach && sach !== '0' ? (sach + ' sachets') : '';
      if (statSachets) statSachets.textContent = sach && sach !== '0' ? sach : '—';
      if (stickyMeta) stickyMeta.textContent = label.trim();

      Array.prototype.forEach.call(packs, function (o) { o.classList.remove('is-on'); });
      btn.classList.add('is-on');
    }

    Array.prototype.forEach.call(packs, function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-available') === 'false') return;
        applyPack(btn);
      });
    });

    /* initial paint — the selected pack, else the first */
    var initial = root.querySelector('[data-bsdp-pack].is-on') || packs[0];
    if (initial) applyPack(initial);
    else if (statSachets) {
      /* single-variant products still get the per-cup + sachet figures */
      var only = root.querySelector('[data-bs-variant-id]');
      if (only && perCup) perCup.textContent = '';
    }

    /* ---------- FAQ accordion ---------- */
    var faqBtns = root.querySelectorAll('[data-bsdp-faq]');
    Array.prototype.forEach.call(faqBtns, function (b) {
      b.addEventListener('click', function () {
        var body = b.parentElement.querySelector('[data-bsdp-faq-body]');
        var ic = b.querySelector('.bsdp__faq-ic');
        var open = body && body.style.display === 'block';
        Array.prototype.forEach.call(faqBtns, function (o) {
          var ob = o.parentElement.querySelector('[data-bsdp-faq-body]');
          var oi = o.querySelector('.bsdp__faq-ic');
          if (ob) ob.style.display = 'none';
          if (oi) oi.textContent = '+';
          o.setAttribute('aria-expanded', 'false');
        });
        if (!open && body) {
          body.style.display = 'block';
          if (ic) ic.textContent = '−';
          b.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---------- jump-to-buy (closing CTA + sticky) ---------- */
    var addBtn = root.querySelector('[data-bsdp-add]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-bsdp-jump]'), function (j) {
      j.addEventListener('click', function () { if (addBtn) addBtn.click(); });
    });

    /* ---------- sticky bar ---------- */
    var sticky = root.querySelector('[data-bsdp-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      try {
        new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var e = entries[i];
            if (!e.isIntersecting && e.boundingClientRect.top < 0) sticky.classList.add('is-on');
            else sticky.classList.remove('is-on');
          }
        }, { threshold: 0 }).observe(addBtn);
      } catch (e) {}
    }
  }

  ready(boot);
  var n = 0;
  var iv = setInterval(function () { boot(); if (++n >= 20) clearInterval(iv); }, 300);
})();
;(function(){if(window.__bsRevealSafety)return;window.__bsRevealSafety='v1';
function sweep(){var els=document.querySelectorAll('.reveal:not(.is-in)');for(var i=0;i<els.length;i++){var el=els[i],r=el.getBoundingClientRect();
if(r.height>window.innerHeight*0.75||r.top<window.innerHeight){el.classList.add('is-in');}}}
function boot(){sweep();setTimeout(sweep,1200);setTimeout(function(){var e=document.querySelectorAll('.reveal:not(.is-in)');for(var i=0;i<e.length;i++)e[i].classList.add('is-in');},3000);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
window.addEventListener('load',sweep);})();
